/* tslint:disable */
/* eslint-disable */
//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v12.3.1.0 (NJsonSchema v9.14.1.0 (Newtonsoft.Json v11.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------
// ReSharper disable InconsistentNaming

import axios, { AxiosInstance, AxiosRequestConfig, AxiosResponse } from 'axios';
import { AbpServiceBase } from '../abp-service-base';

export class FlowableFormServiceProxy extends AbpServiceBase {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor() {
        super();
        this.instance = this.ajax;
        this.baseUrl = this.ajaxBaseUrl;
    }

    /**
     * 删除流程表单
     * @param ids (optional) 表单Id集合
     * @return OK
     */
    delete(ids: string | null | undefined): Promise<void> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.251:31080/blade-flow')+ "/flowable/form/delete?";
        if (ids !== undefined)
            url_ += "ids=" + encodeURIComponent("" + ids) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "DELETE",
            url: url_,
            headers: {
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processDelete(_response);
        });
    }

    protected processDelete(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            return Promise.resolve<void>(<any>null);
        }
        return Promise.resolve<void>(<any>null);
    }

    /**
     * 自定义查询列表
     * @param createBy (optional) 
     * @param createDate (optional) 
     * @param createTime (optional) 
     * @param formJson (optional) 表单Json
     * @param formKey (optional) 表单Key
     * @param formName (optional) 表单名称
     * @param pageNo pageNo
     * @param pageSize pageSize
     * @param updateBy (optional) 
     * @param updateDate (optional) 
     * @param updateTime (optional) 
     * @return OK
     */
    list(createBy: string | null | undefined, createDate: Date | null | undefined, createTime: Date | null | undefined, formJson: string | null | undefined, formKey: string | null | undefined, formName: string | null | undefined, pageNo: number, pageSize: number, updateBy: string | null | undefined, updateDate: Date | null | undefined, updateTime: Date | null | undefined): Promise<IPageOfFlowableForm> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.251:31080/blade-flow')+ "/flowable/form/list?";
        if (createBy !== undefined)
            url_ += "createBy=" + encodeURIComponent("" + createBy) + "&"; 
        if (createDate !== undefined)
            url_ += "createDate=" + encodeURIComponent(createDate ? "" + createDate.toJSON() : "") + "&"; 
        if (createTime !== undefined)
            url_ += "createTime=" + encodeURIComponent(createTime ? "" + createTime.toJSON() : "") + "&"; 
        if (formJson !== undefined)
            url_ += "formJson=" + encodeURIComponent("" + formJson) + "&"; 
        if (formKey !== undefined)
            url_ += "formKey=" + encodeURIComponent("" + formKey) + "&"; 
        if (formName !== undefined)
            url_ += "formName=" + encodeURIComponent("" + formName) + "&"; 
        if (updateBy !== undefined)
            url_ += "updateBy=" + encodeURIComponent("" + updateBy) + "&"; 
        if (updateDate !== undefined)
            url_ += "updateDate=" + encodeURIComponent(updateDate ? "" + updateDate.toJSON() : "") + "&"; 
        if (updateTime !== undefined)
            url_ += "updateTime=" + encodeURIComponent(updateTime ? "" + updateTime.toJSON() : "") + "&"; 
        if (pageNo === undefined || pageNo === null)
            throw new Error("The parameter 'pageNo' must be defined and cannot be null.");
        else
            url_ += "pageNo=" + encodeURIComponent("" + pageNo) + "&"; 
        if (pageSize === undefined || pageSize === null)
            throw new Error("The parameter 'pageSize' must be defined and cannot be null.");
        else
            url_ += "pageSize=" + encodeURIComponent("" + pageSize) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processList(_response);
        });
    }

    protected processList(response: AxiosResponse): Promise<IPageOfFlowableForm> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 ? IPageOfFlowableForm.fromJS(resultData200) : new IPageOfFlowableForm();
            return result200;
        }
        return Promise.resolve<IPageOfFlowableForm>(<any>null);
    }

    /**
     * 获取表单信息
     * @param id (optional) 表单Id
     * @return OK
     */
    queryById(id: string | null | undefined): Promise<FlowableForm> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.251:31080/blade-flow')+ "/flowable/form/queryById?";
        if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processQueryById(_response);
        });
    }

    protected processQueryById(response: AxiosResponse): Promise<FlowableForm> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 ? FlowableForm.fromJS(resultData200) : new FlowableForm();
            return result200;
        }
        return Promise.resolve<FlowableForm>(<any>null);
    }

    /**
     * 新增流程表单
     * @param flowableForm flowableForm
     * @return OK
     */
    save(flowableForm: FlowableForm): Promise<void> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.251:31080/blade-flow')+ "/flowable/form/save";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(flowableForm);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json", 
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processSave(_response);
        });
    }

    protected processSave(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            return Promise.resolve<void>(<any>null);
        }
        return Promise.resolve<void>(<any>null);
    }

    /**
     * 修改流程表单
     * @param flowableForm flowableForm
     * @return OK
     */
    update(flowableForm: FlowableForm): Promise<void> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.251:31080/blade-flow')+ "/flowable/form/update";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(flowableForm);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json", 
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processUpdate(_response);
        });
    }

    protected processUpdate(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            return Promise.resolve<void>(<any>null);
        }
        return Promise.resolve<void>(<any>null);
    }
}

export class FlowableModelServiceProxy extends AbpServiceBase {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor() {
        super();
        this.instance = this.ajax;
        this.baseUrl = this.ajaxBaseUrl;
    }

    /**
     * 删除流程模型
     * @param cascade (optional) 级联删除
     * @param ids (optional) 模型id集合
     * @return OK
     */
    delete(cascade: boolean | null | undefined, ids: string | null | undefined): Promise<void> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.251:31080/blade-flow')+ "/flowable/model/delete?";
        if (cascade !== undefined)
            url_ += "cascade=" + encodeURIComponent("" + cascade) + "&"; 
        if (ids !== undefined)
            url_ += "ids=" + encodeURIComponent("" + ids) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "DELETE",
            url: url_,
            headers: {
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processDelete(_response);
        });
    }

    protected processDelete(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            return Promise.resolve<void>(<any>null);
        }
        return Promise.resolve<void>(<any>null);
    }

    /**
     * 部署流程模型
     * @param modelRequest modelRequest
     * @return OK
     */
    deployModel(modelRequest: ModelRequest): Promise<void> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.251:31080/blade-flow')+ "/flowable/model/deploy";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(modelRequest);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json", 
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processDeployModel(_response);
        });
    }

    protected processDeployModel(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            return Promise.resolve<void>(<any>null);
        }
        return Promise.resolve<void>(<any>null);
    }

    /**
     * 导入流程模型
     * @param tenantId (optional) 所属租户
     * @return OK
     */
    doImport(tenantId: string | null | undefined): Promise<void> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.251:31080/blade-flow')+ "/flowable/model/import?";
        if (tenantId !== undefined)
            url_ += "tenantId=" + encodeURIComponent("" + tenantId) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "POST",
            url: url_,
            headers: {
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processDoImport(_response);
        });
    }

    protected processDoImport(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            return Promise.resolve<void>(<any>null);
        }
        return Promise.resolve<void>(<any>null);
    }

    /**
     * 查询模型列表
     * @param current (optional) 当前页
     * @param deployed (optional) 是否发布
     * @param deploymentId (optional) 部署ID
     * @param latestVersion (optional) 是否是最新版本
     * @param modelCategory (optional) 模型类别
     * @param modelId (optional) 模型ID
     * @param modelKey (optional) 流程模型Key
     * @param modelName (optional) 模型名称
     * @param modelVersion (optional) 模型版本
     * @param orderRule (optional) 排序规则：orderColumn|DESC,orderColumn|ASC
     * @param size (optional) 分页大小
     * @param tenantId (optional) 所属租户
     * @param userId (optional) 用户Id
     * @return OK
     */
    list(current: number | null | undefined, deployed: boolean | null | undefined, deploymentId: string | null | undefined, latestVersion: boolean | null | undefined, modelCategory: string | null | undefined, modelId: string | null | undefined, modelKey: string | null | undefined, modelName: string | null | undefined, modelVersion: number | null | undefined, orderRule: string | null | undefined, size: number | null | undefined, tenantId: string | null | undefined, userId: string | null | undefined): Promise<FlowablePage> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.251:31080/blade-flow')+ "/flowable/model/list?";
        if (current !== undefined)
            url_ += "current=" + encodeURIComponent("" + current) + "&"; 
        if (deployed !== undefined)
            url_ += "deployed=" + encodeURIComponent("" + deployed) + "&"; 
        if (deploymentId !== undefined)
            url_ += "deploymentId=" + encodeURIComponent("" + deploymentId) + "&"; 
        if (latestVersion !== undefined)
            url_ += "latestVersion=" + encodeURIComponent("" + latestVersion) + "&"; 
        if (modelCategory !== undefined)
            url_ += "modelCategory=" + encodeURIComponent("" + modelCategory) + "&"; 
        if (modelId !== undefined)
            url_ += "modelId=" + encodeURIComponent("" + modelId) + "&"; 
        if (modelKey !== undefined)
            url_ += "modelKey=" + encodeURIComponent("" + modelKey) + "&"; 
        if (modelName !== undefined)
            url_ += "modelName=" + encodeURIComponent("" + modelName) + "&"; 
        if (modelVersion !== undefined)
            url_ += "modelVersion=" + encodeURIComponent("" + modelVersion) + "&"; 
        if (orderRule !== undefined)
            url_ += "orderRule=" + encodeURIComponent("" + orderRule) + "&"; 
        if (size !== undefined)
            url_ += "size=" + encodeURIComponent("" + size) + "&"; 
        if (tenantId !== undefined)
            url_ += "tenantId=" + encodeURIComponent("" + tenantId) + "&"; 
        if (userId !== undefined)
            url_ += "userId=" + encodeURIComponent("" + userId) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processList(_response);
        });
    }

    protected processList(response: AxiosResponse): Promise<FlowablePage> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 ? FlowablePage.fromJS(resultData200) : new FlowablePage();
            return result200;
        }
        return Promise.resolve<FlowablePage>(<any>null);
    }

    /**
     * 获取模型信息
     * @param id (optional) 模型id
     * @return OK
     */
    queryById(id: string | null | undefined): Promise<ModelResponse> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.251:31080/blade-flow')+ "/flowable/model/queryById?";
        if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processQueryById(_response);
        });
    }

    protected processQueryById(response: AxiosResponse): Promise<ModelResponse> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 ? ModelResponse.fromJS(resultData200) : new ModelResponse();
            return result200;
        }
        return Promise.resolve<ModelResponse>(<any>null);
    }

    /**
     * 新增流程模型
     * @param modelRequest modelRequest
     * @return OK
     */
    save(modelRequest: ModelRequest): Promise<void> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.251:31080/blade-flow')+ "/flowable/model/save";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(modelRequest);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json", 
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processSave(_response);
        });
    }

    protected processSave(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            return Promise.resolve<void>(<any>null);
        }
        return Promise.resolve<void>(<any>null);
    }

    /**
     * 保存流程设计
     * @param modelRequest modelRequest
     * @return OK
     */
    saveModelEditor(modelRequest: ModelRequest): Promise<void> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.251:31080/blade-flow')+ "/flowable/model/saveModelEditor";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(modelRequest);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json", 
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processSaveModelEditor(_response);
        });
    }

    protected processSaveModelEditor(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            return Promise.resolve<void>(<any>null);
        }
        return Promise.resolve<void>(<any>null);
    }

    /**
     * 修改流程模型
     * @param modelRequest modelRequest
     * @return OK
     */
    update(modelRequest: ModelRequest): Promise<void> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.251:31080/blade-flow')+ "/flowable/model/update";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(modelRequest);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json", 
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processUpdate(_response);
        });
    }

    protected processUpdate(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            return Promise.resolve<void>(<any>null);
        }
        return Promise.resolve<void>(<any>null);
    }
}

export class ProcessDefinitionServiceProxy extends AbpServiceBase {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor() {
        super();
        this.instance = this.ajax;
        this.baseUrl = this.ajaxBaseUrl;
    }

    /**
     * 激活流程定义
     * @param actionRequest actionRequest
     * @return OK
     */
    activate(actionRequest: ProcessDefinitionRequest): Promise<void> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.251:31080/blade-flow')+ "/flowable/processDefinition/activate";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(actionRequest);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json", 
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processActivate(_response);
        });
    }

    protected processActivate(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            return Promise.resolve<void>(<any>null);
        }
        return Promise.resolve<void>(<any>null);
    }

    /**
     * 删除流程定义
     * @param cascade (optional) 级联删除流程定义
     * @param processDefinitionId (optional) 流程定义ID
     * @return OK
     */
    delete(cascade: boolean | null | undefined, processDefinitionId: string | null | undefined): Promise<void> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.251:31080/blade-flow')+ "/flowable/processDefinition/delete?";
        if (cascade !== undefined)
            url_ += "cascade=" + encodeURIComponent("" + cascade) + "&"; 
        if (processDefinitionId !== undefined)
            url_ += "processDefinitionId=" + encodeURIComponent("" + processDefinitionId) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "DELETE",
            url: url_,
            headers: {
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processDelete(_response);
        });
    }

    protected processDelete(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            return Promise.resolve<void>(<any>null);
        }
        return Promise.resolve<void>(<any>null);
    }

    /**
     * 获取流程定义流程图
     * @param processDefinitionId (optional) 流程定义ID
     * @return OK
     */
    image(processDefinitionId: string | null | undefined): Promise<string> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.251:31080/blade-flow')+ "/flowable/processDefinition/image?";
        if (processDefinitionId !== undefined)
            url_ += "processDefinitionId=" + encodeURIComponent("" + processDefinitionId) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processImage(_response);
        });
    }

    protected processImage(response: AxiosResponse): Promise<string> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return result200;
        }
        return Promise.resolve<string>(<any>null);
    }

    /**
     * 导入流程定义
     * @param tenantId (optional) 所属租户
     * @return OK
     */
    doImport(tenantId: string | null | undefined): Promise<void> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.251:31080/blade-flow')+ "/flowable/processDefinition/import?";
        if (tenantId !== undefined)
            url_ += "tenantId=" + encodeURIComponent("" + tenantId) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "POST",
            url: url_,
            headers: {
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processDoImport(_response);
        });
    }

    protected processDoImport(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            return Promise.resolve<void>(<any>null);
        }
        return Promise.resolve<void>(<any>null);
    }

    /**
     * 查询流程定义列表
     * @param active (optional) 激活
     * @param current (optional) 当前页
     * @param latestVersion (optional) 最新版本
     * @param orderRule (optional) 排序规则：orderColumn|DESC,orderColumn|ASC
     * @param processDefinitionCategory (optional) 流程定义分类
     * @param processDefinitionId (optional) 流程定义ID
     * @param processDefinitionKey (optional) 流程定义Key
     * @param processDefinitionName (optional) 流程定义名称
     * @param processDefinitionVersion (optional) 版本
     * @param size (optional) 分页大小
     * @param startableByUser (optional) 可发起人员，暂时忽略，后台自动设定
     * @param suspended (optional) 挂起
     * @param tenantId (optional) 所属租户
     * @param userId (optional) 用户Id
     * @return OK
     */
    list(active: boolean | null | undefined, current: number | null | undefined, latestVersion: boolean | null | undefined, orderRule: string | null | undefined, processDefinitionCategory: string | null | undefined, processDefinitionId: string | null | undefined, processDefinitionKey: string | null | undefined, processDefinitionName: string | null | undefined, processDefinitionVersion: number | null | undefined, size: number | null | undefined, startableByUser: string | null | undefined, suspended: boolean | null | undefined, tenantId: string | null | undefined, userId: string | null | undefined): Promise<FlowablePage> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.251:31080/blade-flow')+ "/flowable/processDefinition/list?";
        if (active !== undefined)
            url_ += "active=" + encodeURIComponent("" + active) + "&"; 
        if (current !== undefined)
            url_ += "current=" + encodeURIComponent("" + current) + "&"; 
        if (latestVersion !== undefined)
            url_ += "latestVersion=" + encodeURIComponent("" + latestVersion) + "&"; 
        if (orderRule !== undefined)
            url_ += "orderRule=" + encodeURIComponent("" + orderRule) + "&"; 
        if (processDefinitionCategory !== undefined)
            url_ += "processDefinitionCategory=" + encodeURIComponent("" + processDefinitionCategory) + "&"; 
        if (processDefinitionId !== undefined)
            url_ += "processDefinitionId=" + encodeURIComponent("" + processDefinitionId) + "&"; 
        if (processDefinitionKey !== undefined)
            url_ += "processDefinitionKey=" + encodeURIComponent("" + processDefinitionKey) + "&"; 
        if (processDefinitionName !== undefined)
            url_ += "processDefinitionName=" + encodeURIComponent("" + processDefinitionName) + "&"; 
        if (processDefinitionVersion !== undefined)
            url_ += "processDefinitionVersion=" + encodeURIComponent("" + processDefinitionVersion) + "&"; 
        if (size !== undefined)
            url_ += "size=" + encodeURIComponent("" + size) + "&"; 
        if (startableByUser !== undefined)
            url_ += "startableByUser=" + encodeURIComponent("" + startableByUser) + "&"; 
        if (suspended !== undefined)
            url_ += "suspended=" + encodeURIComponent("" + suspended) + "&"; 
        if (tenantId !== undefined)
            url_ += "tenantId=" + encodeURIComponent("" + tenantId) + "&"; 
        if (userId !== undefined)
            url_ += "userId=" + encodeURIComponent("" + userId) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processList(_response);
        });
    }

    protected processList(response: AxiosResponse): Promise<FlowablePage> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 ? FlowablePage.fromJS(resultData200) : new FlowablePage();
            return result200;
        }
        return Promise.resolve<FlowablePage>(<any>null);
    }

    /**
     * 查询当前用户可用流程定义列表
     * @param active (optional) 激活
     * @param current (optional) 当前页
     * @param latestVersion (optional) 最新版本
     * @param orderRule (optional) 排序规则：orderColumn|DESC,orderColumn|ASC
     * @param processDefinitionCategory (optional) 流程定义分类
     * @param processDefinitionId (optional) 流程定义ID
     * @param processDefinitionKey (optional) 流程定义Key
     * @param processDefinitionName (optional) 流程定义名称
     * @param processDefinitionVersion (optional) 版本
     * @param size (optional) 分页大小
     * @param startableByUser (optional) 可发起人员，暂时忽略，后台自动设定
     * @param suspended (optional) 挂起
     * @param tenantId (optional) 所属租户
     * @param userId (optional) 用户Id
     * @return OK
     */
    listMyself(active: boolean | null | undefined, current: number | null | undefined, latestVersion: boolean | null | undefined, orderRule: string | null | undefined, processDefinitionCategory: string | null | undefined, processDefinitionId: string | null | undefined, processDefinitionKey: string | null | undefined, processDefinitionName: string | null | undefined, processDefinitionVersion: number | null | undefined, size: number | null | undefined, startableByUser: string | null | undefined, suspended: boolean | null | undefined, tenantId: string | null | undefined, userId: string | null | undefined): Promise<FlowablePage> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.251:31080/blade-flow')+ "/flowable/processDefinition/listMyself?";
        if (active !== undefined)
            url_ += "active=" + encodeURIComponent("" + active) + "&"; 
        if (current !== undefined)
            url_ += "current=" + encodeURIComponent("" + current) + "&"; 
        if (latestVersion !== undefined)
            url_ += "latestVersion=" + encodeURIComponent("" + latestVersion) + "&"; 
        if (orderRule !== undefined)
            url_ += "orderRule=" + encodeURIComponent("" + orderRule) + "&"; 
        if (processDefinitionCategory !== undefined)
            url_ += "processDefinitionCategory=" + encodeURIComponent("" + processDefinitionCategory) + "&"; 
        if (processDefinitionId !== undefined)
            url_ += "processDefinitionId=" + encodeURIComponent("" + processDefinitionId) + "&"; 
        if (processDefinitionKey !== undefined)
            url_ += "processDefinitionKey=" + encodeURIComponent("" + processDefinitionKey) + "&"; 
        if (processDefinitionName !== undefined)
            url_ += "processDefinitionName=" + encodeURIComponent("" + processDefinitionName) + "&"; 
        if (processDefinitionVersion !== undefined)
            url_ += "processDefinitionVersion=" + encodeURIComponent("" + processDefinitionVersion) + "&"; 
        if (size !== undefined)
            url_ += "size=" + encodeURIComponent("" + size) + "&"; 
        if (startableByUser !== undefined)
            url_ += "startableByUser=" + encodeURIComponent("" + startableByUser) + "&"; 
        if (suspended !== undefined)
            url_ += "suspended=" + encodeURIComponent("" + suspended) + "&"; 
        if (tenantId !== undefined)
            url_ += "tenantId=" + encodeURIComponent("" + tenantId) + "&"; 
        if (userId !== undefined)
            url_ += "userId=" + encodeURIComponent("" + userId) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processListMyself(_response);
        });
    }

    protected processListMyself(response: AxiosResponse): Promise<FlowablePage> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 ? FlowablePage.fromJS(resultData200) : new FlowablePage();
            return result200;
        }
        return Promise.resolve<FlowablePage>(<any>null);
    }

    /**
     * 获取指定流程定义
     * @param processDefinitionId (optional) 流程定义ID
     * @return OK
     */
    queryById(processDefinitionId: string | null | undefined): Promise<ProcessDefinitionResponse> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.251:31080/blade-flow')+ "/flowable/processDefinition/queryById?";
        if (processDefinitionId !== undefined)
            url_ += "processDefinitionId=" + encodeURIComponent("" + processDefinitionId) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processQueryById(_response);
        });
    }

    protected processQueryById(response: AxiosResponse): Promise<ProcessDefinitionResponse> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 ? ProcessDefinitionResponse.fromJS(resultData200) : new ProcessDefinitionResponse();
            return result200;
        }
        return Promise.resolve<ProcessDefinitionResponse>(<any>null);
    }

    /**
     * 渲染指定流程开始表单
     * @param processDefinitionId (optional) 流程定义ID
     * @return OK
     */
    renderedStartForm(processDefinitionId: string | null | undefined): Promise<{ [key: string] : any; }> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.251:31080/blade-flow')+ "/flowable/processDefinition/renderedStartForm?";
        if (processDefinitionId !== undefined)
            url_ += "processDefinitionId=" + encodeURIComponent("" + processDefinitionId) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processRenderedStartForm(_response);
        });
    }

    protected processRenderedStartForm(response: AxiosResponse): Promise<{ [key: string] : any; }> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            if (resultData200) {
                result200 = {} as any;
                for (let key in resultData200) {
                    if (resultData200.hasOwnProperty(key))
                        result200![key] = resultData200[key];
                }
            }
            return result200;
        }
        return Promise.resolve<{ [key: string] : any; }>(<any>null);
    }

    /**
     * 挂起流程定义
     * @param actionRequest actionRequest
     * @return OK
     */
    suspend(actionRequest: ProcessDefinitionRequest): Promise<void> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.251:31080/blade-flow')+ "/flowable/processDefinition/suspend";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(actionRequest);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json", 
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processSuspend(_response);
        });
    }

    protected processSuspend(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            return Promise.resolve<void>(<any>null);
        }
        return Promise.resolve<void>(<any>null);
    }

    /**
     * 获取流程定义XML信息异常
     * @param processDefinitionId (optional) 流程定义ID
     * @return OK
     */
    xml(processDefinitionId: string | null | undefined): Promise<string> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.251:31080/blade-flow')+ "/flowable/processDefinition/xml?";
        if (processDefinitionId !== undefined)
            url_ += "processDefinitionId=" + encodeURIComponent("" + processDefinitionId) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processXml(_response);
        });
    }

    protected processXml(response: AxiosResponse): Promise<string> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return result200;
        }
        return Promise.resolve<string>(<any>null);
    }
}

export class ProcessDefinitionIdentityLinkServiceProxy extends AbpServiceBase {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor() {
        super();
        this.instance = this.ajax;
        this.baseUrl = this.ajaxBaseUrl;
    }

    /**
     * delete
     * @param identityId (optional) 流程授权的对象ID
     * @param identityType (optional) 授权类型
     * @param processDefinitionId (optional) 流程定义ID
     * @return OK
     */
    delete(identityId: string | null | undefined, identityType: string | null | undefined, processDefinitionId: string | null | undefined): Promise<void> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.251:31080/blade-flow')+ "/flowable/processDefinitionIdentityLink/delete?";
        if (identityId !== undefined)
            url_ += "identityId=" + encodeURIComponent("" + identityId) + "&"; 
        if (identityType !== undefined)
            url_ += "identityType=" + encodeURIComponent("" + identityType) + "&"; 
        if (processDefinitionId !== undefined)
            url_ += "processDefinitionId=" + encodeURIComponent("" + processDefinitionId) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "DELETE",
            url: url_,
            headers: {
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processDelete(_response);
        });
    }

    protected processDelete(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            return Promise.resolve<void>(<any>null);
        }
        return Promise.resolve<void>(<any>null);
    }

    /**
     * 查询指定流程授权列表
     * @param processDefinitionId (optional) 流程定义ID
     * @return OK
     */
    list(processDefinitionId: string | null | undefined): Promise<IdentityResponse[]> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.251:31080/blade-flow')+ "/flowable/processDefinitionIdentityLink/list?";
        if (processDefinitionId !== undefined)
            url_ += "processDefinitionId=" + encodeURIComponent("" + processDefinitionId) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processList(_response);
        });
    }

    protected processList(response: AxiosResponse): Promise<IdentityResponse[]> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            if (resultData200 && resultData200.constructor === Array) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(IdentityResponse.fromJS(item));
            }
            return result200;
        }
        return Promise.resolve<IdentityResponse[]>(<any>null);
    }

    /**
     * save
     * @param identityRequest identityRequest
     * @return OK
     */
    save(identityRequest: IdentityRequest): Promise<void> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.251:31080/blade-flow')+ "/flowable/processDefinitionIdentityLink/save";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(identityRequest);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json", 
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processSave(_response);
        });
    }

    protected processSave(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            return Promise.resolve<void>(<any>null);
        }
        return Promise.resolve<void>(<any>null);
    }
}

export class ProcessDefinitionJobServiceProxy extends AbpServiceBase {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor() {
        super();
        this.instance = this.ajax;
        this.baseUrl = this.ajaxBaseUrl;
    }

    /**
     * 删除流程定义定时任务
     * @param jobId (optional) 定时任务ID
     * @return OK
     */
    deleteJob(jobId: string | null | undefined): Promise<void> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.251:31080/blade-flow')+ "/flowable/processDefinitionJob/delete?";
        if (jobId !== undefined)
            url_ += "jobId=" + encodeURIComponent("" + jobId) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "DELETE",
            url: url_,
            headers: {
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processDeleteJob(_response);
        });
    }

    protected processDeleteJob(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            return Promise.resolve<void>(<any>null);
        }
        return Promise.resolve<void>(<any>null);
    }

    /**
     * 流程定义定时任务列表
     * @param processDefinitionId (optional) 流程定义ID
     * @return OK
     */
    list(processDefinitionId: string | null | undefined): Promise<Job[]> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.251:31080/blade-flow')+ "/flowable/processDefinitionJob/list?";
        if (processDefinitionId !== undefined)
            url_ += "processDefinitionId=" + encodeURIComponent("" + processDefinitionId) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processList(_response);
        });
    }

    protected processList(response: AxiosResponse): Promise<Job[]> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            if (resultData200 && resultData200.constructor === Array) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(Job.fromJS(item));
            }
            return result200;
        }
        return Promise.resolve<Job[]>(<any>null);
    }
}

export class ProcessInstanceServiceProxy extends AbpServiceBase {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor() {
        super();
        this.instance = this.ajax;
        this.baseUrl = this.ajaxBaseUrl;
    }

    /**
     * 激活流程实例
     * @param processInstanceRequest processInstanceRequest
     * @return OK
     */
    activate(processInstanceRequest: ProcessInstanceRequest): Promise<void> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.251:31080/blade-flow')+ "/flowable/processInstance/activate";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(processInstanceRequest);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json", 
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processActivate(_response);
        });
    }

    protected processActivate(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            return Promise.resolve<void>(<any>null);
        }
        return Promise.resolve<void>(<any>null);
    }

    /**
     * 获取流程处理记录
     * @param processInstanceId (optional) 流程实例ID
     * @return OK
     */
    comments(processInstanceId: string | null | undefined): Promise<CommentResponse[]> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.251:31080/blade-flow')+ "/flowable/processInstance/comments?";
        if (processInstanceId !== undefined)
            url_ += "processInstanceId=" + encodeURIComponent("" + processInstanceId) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processComments(_response);
        });
    }

    protected processComments(response: AxiosResponse): Promise<CommentResponse[]> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            if (resultData200 && resultData200.constructor === Array) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(CommentResponse.fromJS(item));
            }
            return result200;
        }
        return Promise.resolve<CommentResponse[]>(<any>null);
    }

    /**
     * 删除流程实例
     * @param cascade (optional) 级联删除流程实例
     * @param deleteReason (optional) deleteReason
     * @param processInstanceId (optional) 流程实例ID
     * @return OK
     */
    delete(cascade: boolean | null | undefined, deleteReason: string | null | undefined, processInstanceId: string | null | undefined): Promise<void> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.251:31080/blade-flow')+ "/flowable/processInstance/delete?";
        if (cascade !== undefined)
            url_ += "cascade=" + encodeURIComponent("" + cascade) + "&"; 
        if (processInstanceId !== undefined)
            url_ += "processInstanceId=" + encodeURIComponent("" + processInstanceId) + "&"; 
        if (deleteReason !== undefined)
            url_ += "deleteReason=" + encodeURIComponent("" + deleteReason) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "DELETE",
            url: url_,
            headers: {
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processDelete(_response);
        });
    }

    protected processDelete(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            return Promise.resolve<void>(<any>null);
        }
        return Promise.resolve<void>(<any>null);
    }

    /**
     * 获取流程实例表单数据
     * @param processInstanceId processInstanceId
     * @return OK
     */
    formData(processInstanceId: string): Promise<any> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.251:31080/blade-flow')+ "/flowable/processInstance/formData?";
        if (processInstanceId === undefined || processInstanceId === null)
            throw new Error("The parameter 'processInstanceId' must be defined and cannot be null.");
        else
            url_ += "processInstanceId=" + encodeURIComponent("" + processInstanceId) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processFormData(_response);
        });
    }

    protected processFormData(response: AxiosResponse): Promise<any> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return result200;
        }
        return Promise.resolve<any>(<any>null);
    }

    /**
     * 查询流程实例列表
     * @param businessKey (optional) 业务主键KEY
     * @param ccToMe (optional) 是否抄送给我
     * @param current (optional) 当前页
     * @param excludeSubprocesses (optional) 是否包含子流程(初期忽略此字段)
     * @param finished (optional) 已办结
     * @param finishedAfter (optional) 结束时间范围(After)
     * @param finishedBefore (optional) 结束时间范围(Before)
     * @param involvedUser (optional) 参与用户
     * @param orderRule (optional) 排序规则：orderColumn|DESC,orderColumn|ASC
     * @param processDefinitionCategory (optional) 流程定义分类
     * @param processDefinitionId (optional) 流程定义ID
     * @param processDefinitionKey (optional) 流程定义Key
     * @param processDefinitionName (optional) 流程定义Name
     * @param processInstanceId (optional) 流程实例ID
     * @param processInstanceName (optional) 流程实例名称
     * @param size (optional) 分页大小
     * @param startedAfter (optional) 开始时间范围(After)
     * @param startedBefore (optional) 开始时间范围(Before)
     * @param startedBy (optional) 启动人
     * @param startedByMe (optional) 是否我发起得
     * @param superProcessInstanceId (optional) 子流程ID
     * @param tenantId (optional) 所属租户
     * @param unfinished (optional) 未办结
     * @param userId (optional) 用户Id
     * @return OK
     */
    list(businessKey: string | null | undefined, ccToMe: boolean | null | undefined, current: number | null | undefined, excludeSubprocesses: boolean | null | undefined, finished: boolean | null | undefined, finishedAfter: string | null | undefined, finishedBefore: string | null | undefined, involvedUser: string | null | undefined, orderRule: string | null | undefined, processDefinitionCategory: string | null | undefined, processDefinitionId: string | null | undefined, processDefinitionKey: string | null | undefined, processDefinitionName: string | null | undefined, processInstanceId: string | null | undefined, processInstanceName: string | null | undefined, size: number | null | undefined, startedAfter: string | null | undefined, startedBefore: string | null | undefined, startedBy: string | null | undefined, startedByMe: boolean | null | undefined, superProcessInstanceId: string | null | undefined, tenantId: string | null | undefined, unfinished: boolean | null | undefined, userId: string | null | undefined): Promise<FlowablePage> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.251:31080/blade-flow')+ "/flowable/processInstance/list?";
        if (businessKey !== undefined)
            url_ += "businessKey=" + encodeURIComponent("" + businessKey) + "&"; 
        if (ccToMe !== undefined)
            url_ += "ccToMe=" + encodeURIComponent("" + ccToMe) + "&"; 
        if (current !== undefined)
            url_ += "current=" + encodeURIComponent("" + current) + "&"; 
        if (excludeSubprocesses !== undefined)
            url_ += "excludeSubprocesses=" + encodeURIComponent("" + excludeSubprocesses) + "&"; 
        if (finished !== undefined)
            url_ += "finished=" + encodeURIComponent("" + finished) + "&"; 
        if (finishedAfter !== undefined)
            url_ += "finishedAfter=" + encodeURIComponent("" + finishedAfter) + "&"; 
        if (finishedBefore !== undefined)
            url_ += "finishedBefore=" + encodeURIComponent("" + finishedBefore) + "&"; 
        if (involvedUser !== undefined)
            url_ += "involvedUser=" + encodeURIComponent("" + involvedUser) + "&"; 
        if (orderRule !== undefined)
            url_ += "orderRule=" + encodeURIComponent("" + orderRule) + "&"; 
        if (processDefinitionCategory !== undefined)
            url_ += "processDefinitionCategory=" + encodeURIComponent("" + processDefinitionCategory) + "&"; 
        if (processDefinitionId !== undefined)
            url_ += "processDefinitionId=" + encodeURIComponent("" + processDefinitionId) + "&"; 
        if (processDefinitionKey !== undefined)
            url_ += "processDefinitionKey=" + encodeURIComponent("" + processDefinitionKey) + "&"; 
        if (processDefinitionName !== undefined)
            url_ += "processDefinitionName=" + encodeURIComponent("" + processDefinitionName) + "&"; 
        if (processInstanceId !== undefined)
            url_ += "processInstanceId=" + encodeURIComponent("" + processInstanceId) + "&"; 
        if (processInstanceName !== undefined)
            url_ += "processInstanceName=" + encodeURIComponent("" + processInstanceName) + "&"; 
        if (size !== undefined)
            url_ += "size=" + encodeURIComponent("" + size) + "&"; 
        if (startedAfter !== undefined)
            url_ += "startedAfter=" + encodeURIComponent("" + startedAfter) + "&"; 
        if (startedBefore !== undefined)
            url_ += "startedBefore=" + encodeURIComponent("" + startedBefore) + "&"; 
        if (startedBy !== undefined)
            url_ += "startedBy=" + encodeURIComponent("" + startedBy) + "&"; 
        if (startedByMe !== undefined)
            url_ += "startedByMe=" + encodeURIComponent("" + startedByMe) + "&"; 
        if (superProcessInstanceId !== undefined)
            url_ += "superProcessInstanceId=" + encodeURIComponent("" + superProcessInstanceId) + "&"; 
        if (tenantId !== undefined)
            url_ += "tenantId=" + encodeURIComponent("" + tenantId) + "&"; 
        if (unfinished !== undefined)
            url_ += "unfinished=" + encodeURIComponent("" + unfinished) + "&"; 
        if (userId !== undefined)
            url_ += "userId=" + encodeURIComponent("" + userId) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processList(_response);
        });
    }

    protected processList(response: AxiosResponse): Promise<FlowablePage> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 ? FlowablePage.fromJS(resultData200) : new FlowablePage();
            return result200;
        }
        return Promise.resolve<FlowablePage>(<any>null);
    }

    /**
     * 查询抄送我的流程实例
     * @param businessKey (optional) 业务主键KEY
     * @param ccToMe (optional) 是否抄送给我
     * @param current (optional) 当前页
     * @param excludeSubprocesses (optional) 是否包含子流程(初期忽略此字段)
     * @param finished (optional) 已办结
     * @param finishedAfter (optional) 结束时间范围(After)
     * @param finishedBefore (optional) 结束时间范围(Before)
     * @param involvedUser (optional) 参与用户
     * @param orderRule (optional) 排序规则：orderColumn|DESC,orderColumn|ASC
     * @param processDefinitionCategory (optional) 流程定义分类
     * @param processDefinitionId (optional) 流程定义ID
     * @param processDefinitionKey (optional) 流程定义Key
     * @param processDefinitionName (optional) 流程定义Name
     * @param processInstanceId (optional) 流程实例ID
     * @param processInstanceName (optional) 流程实例名称
     * @param size (optional) 分页大小
     * @param startedAfter (optional) 开始时间范围(After)
     * @param startedBefore (optional) 开始时间范围(Before)
     * @param startedBy (optional) 启动人
     * @param startedByMe (optional) 是否我发起得
     * @param superProcessInstanceId (optional) 子流程ID
     * @param tenantId (optional) 所属租户
     * @param unfinished (optional) 未办结
     * @param userId (optional) 用户Id
     * @return OK
     */
    listCcToMe(businessKey: string | null | undefined, ccToMe: boolean | null | undefined, current: number | null | undefined, excludeSubprocesses: boolean | null | undefined, finished: boolean | null | undefined, finishedAfter: string | null | undefined, finishedBefore: string | null | undefined, involvedUser: string | null | undefined, orderRule: string | null | undefined, processDefinitionCategory: string | null | undefined, processDefinitionId: string | null | undefined, processDefinitionKey: string | null | undefined, processDefinitionName: string | null | undefined, processInstanceId: string | null | undefined, processInstanceName: string | null | undefined, size: number | null | undefined, startedAfter: string | null | undefined, startedBefore: string | null | undefined, startedBy: string | null | undefined, startedByMe: boolean | null | undefined, superProcessInstanceId: string | null | undefined, tenantId: string | null | undefined, unfinished: boolean | null | undefined, userId: string | null | undefined): Promise<FlowablePage> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.251:31080/blade-flow')+ "/flowable/processInstance/listCcToMe?";
        if (businessKey !== undefined)
            url_ += "businessKey=" + encodeURIComponent("" + businessKey) + "&"; 
        if (ccToMe !== undefined)
            url_ += "ccToMe=" + encodeURIComponent("" + ccToMe) + "&"; 
        if (current !== undefined)
            url_ += "current=" + encodeURIComponent("" + current) + "&"; 
        if (excludeSubprocesses !== undefined)
            url_ += "excludeSubprocesses=" + encodeURIComponent("" + excludeSubprocesses) + "&"; 
        if (finished !== undefined)
            url_ += "finished=" + encodeURIComponent("" + finished) + "&"; 
        if (finishedAfter !== undefined)
            url_ += "finishedAfter=" + encodeURIComponent("" + finishedAfter) + "&"; 
        if (finishedBefore !== undefined)
            url_ += "finishedBefore=" + encodeURIComponent("" + finishedBefore) + "&"; 
        if (involvedUser !== undefined)
            url_ += "involvedUser=" + encodeURIComponent("" + involvedUser) + "&"; 
        if (orderRule !== undefined)
            url_ += "orderRule=" + encodeURIComponent("" + orderRule) + "&"; 
        if (processDefinitionCategory !== undefined)
            url_ += "processDefinitionCategory=" + encodeURIComponent("" + processDefinitionCategory) + "&"; 
        if (processDefinitionId !== undefined)
            url_ += "processDefinitionId=" + encodeURIComponent("" + processDefinitionId) + "&"; 
        if (processDefinitionKey !== undefined)
            url_ += "processDefinitionKey=" + encodeURIComponent("" + processDefinitionKey) + "&"; 
        if (processDefinitionName !== undefined)
            url_ += "processDefinitionName=" + encodeURIComponent("" + processDefinitionName) + "&"; 
        if (processInstanceId !== undefined)
            url_ += "processInstanceId=" + encodeURIComponent("" + processInstanceId) + "&"; 
        if (processInstanceName !== undefined)
            url_ += "processInstanceName=" + encodeURIComponent("" + processInstanceName) + "&"; 
        if (size !== undefined)
            url_ += "size=" + encodeURIComponent("" + size) + "&"; 
        if (startedAfter !== undefined)
            url_ += "startedAfter=" + encodeURIComponent("" + startedAfter) + "&"; 
        if (startedBefore !== undefined)
            url_ += "startedBefore=" + encodeURIComponent("" + startedBefore) + "&"; 
        if (startedBy !== undefined)
            url_ += "startedBy=" + encodeURIComponent("" + startedBy) + "&"; 
        if (startedByMe !== undefined)
            url_ += "startedByMe=" + encodeURIComponent("" + startedByMe) + "&"; 
        if (superProcessInstanceId !== undefined)
            url_ += "superProcessInstanceId=" + encodeURIComponent("" + superProcessInstanceId) + "&"; 
        if (tenantId !== undefined)
            url_ += "tenantId=" + encodeURIComponent("" + tenantId) + "&"; 
        if (unfinished !== undefined)
            url_ += "unfinished=" + encodeURIComponent("" + unfinished) + "&"; 
        if (userId !== undefined)
            url_ += "userId=" + encodeURIComponent("" + userId) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processListCcToMe(_response);
        });
    }

    protected processListCcToMe(response: AxiosResponse): Promise<FlowablePage> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 ? FlowablePage.fromJS(resultData200) : new FlowablePage();
            return result200;
        }
        return Promise.resolve<FlowablePage>(<any>null);
    }

    /**
     * 查询我参与的流程实例
     * @param businessKey (optional) 业务主键KEY
     * @param ccToMe (optional) 是否抄送给我
     * @param current (optional) 当前页
     * @param excludeSubprocesses (optional) 是否包含子流程(初期忽略此字段)
     * @param finished (optional) 已办结
     * @param finishedAfter (optional) 结束时间范围(After)
     * @param finishedBefore (optional) 结束时间范围(Before)
     * @param involvedUser (optional) 参与用户
     * @param orderRule (optional) 排序规则：orderColumn|DESC,orderColumn|ASC
     * @param processDefinitionCategory (optional) 流程定义分类
     * @param processDefinitionId (optional) 流程定义ID
     * @param processDefinitionKey (optional) 流程定义Key
     * @param processDefinitionName (optional) 流程定义Name
     * @param processInstanceId (optional) 流程实例ID
     * @param processInstanceName (optional) 流程实例名称
     * @param size (optional) 分页大小
     * @param startedAfter (optional) 开始时间范围(After)
     * @param startedBefore (optional) 开始时间范围(Before)
     * @param startedBy (optional) 启动人
     * @param startedByMe (optional) 是否我发起得
     * @param superProcessInstanceId (optional) 子流程ID
     * @param tenantId (optional) 所属租户
     * @param unfinished (optional) 未办结
     * @param userId (optional) 用户Id
     * @return OK
     */
    listMyInvolved(businessKey: string | null | undefined, ccToMe: boolean | null | undefined, current: number | null | undefined, excludeSubprocesses: boolean | null | undefined, finished: boolean | null | undefined, finishedAfter: string | null | undefined, finishedBefore: string | null | undefined, involvedUser: string | null | undefined, orderRule: string | null | undefined, processDefinitionCategory: string | null | undefined, processDefinitionId: string | null | undefined, processDefinitionKey: string | null | undefined, processDefinitionName: string | null | undefined, processInstanceId: string | null | undefined, processInstanceName: string | null | undefined, size: number | null | undefined, startedAfter: string | null | undefined, startedBefore: string | null | undefined, startedBy: string | null | undefined, startedByMe: boolean | null | undefined, superProcessInstanceId: string | null | undefined, tenantId: string | null | undefined, unfinished: boolean | null | undefined, userId: string | null | undefined): Promise<FlowablePage> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.251:31080/blade-flow')+ "/flowable/processInstance/listMyInvolved?";
        if (businessKey !== undefined)
            url_ += "businessKey=" + encodeURIComponent("" + businessKey) + "&"; 
        if (ccToMe !== undefined)
            url_ += "ccToMe=" + encodeURIComponent("" + ccToMe) + "&"; 
        if (current !== undefined)
            url_ += "current=" + encodeURIComponent("" + current) + "&"; 
        if (excludeSubprocesses !== undefined)
            url_ += "excludeSubprocesses=" + encodeURIComponent("" + excludeSubprocesses) + "&"; 
        if (finished !== undefined)
            url_ += "finished=" + encodeURIComponent("" + finished) + "&"; 
        if (finishedAfter !== undefined)
            url_ += "finishedAfter=" + encodeURIComponent("" + finishedAfter) + "&"; 
        if (finishedBefore !== undefined)
            url_ += "finishedBefore=" + encodeURIComponent("" + finishedBefore) + "&"; 
        if (involvedUser !== undefined)
            url_ += "involvedUser=" + encodeURIComponent("" + involvedUser) + "&"; 
        if (orderRule !== undefined)
            url_ += "orderRule=" + encodeURIComponent("" + orderRule) + "&"; 
        if (processDefinitionCategory !== undefined)
            url_ += "processDefinitionCategory=" + encodeURIComponent("" + processDefinitionCategory) + "&"; 
        if (processDefinitionId !== undefined)
            url_ += "processDefinitionId=" + encodeURIComponent("" + processDefinitionId) + "&"; 
        if (processDefinitionKey !== undefined)
            url_ += "processDefinitionKey=" + encodeURIComponent("" + processDefinitionKey) + "&"; 
        if (processDefinitionName !== undefined)
            url_ += "processDefinitionName=" + encodeURIComponent("" + processDefinitionName) + "&"; 
        if (processInstanceId !== undefined)
            url_ += "processInstanceId=" + encodeURIComponent("" + processInstanceId) + "&"; 
        if (processInstanceName !== undefined)
            url_ += "processInstanceName=" + encodeURIComponent("" + processInstanceName) + "&"; 
        if (size !== undefined)
            url_ += "size=" + encodeURIComponent("" + size) + "&"; 
        if (startedAfter !== undefined)
            url_ += "startedAfter=" + encodeURIComponent("" + startedAfter) + "&"; 
        if (startedBefore !== undefined)
            url_ += "startedBefore=" + encodeURIComponent("" + startedBefore) + "&"; 
        if (startedBy !== undefined)
            url_ += "startedBy=" + encodeURIComponent("" + startedBy) + "&"; 
        if (startedByMe !== undefined)
            url_ += "startedByMe=" + encodeURIComponent("" + startedByMe) + "&"; 
        if (superProcessInstanceId !== undefined)
            url_ += "superProcessInstanceId=" + encodeURIComponent("" + superProcessInstanceId) + "&"; 
        if (tenantId !== undefined)
            url_ += "tenantId=" + encodeURIComponent("" + tenantId) + "&"; 
        if (unfinished !== undefined)
            url_ += "unfinished=" + encodeURIComponent("" + unfinished) + "&"; 
        if (userId !== undefined)
            url_ += "userId=" + encodeURIComponent("" + userId) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processListMyInvolved(_response);
        });
    }

    protected processListMyInvolved(response: AxiosResponse): Promise<FlowablePage> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 ? FlowablePage.fromJS(resultData200) : new FlowablePage();
            return result200;
        }
        return Promise.resolve<FlowablePage>(<any>null);
    }

    /**
     * 查询我的流程汇总信息
     * @param businessKey (optional) 业务主键KEY
     * @param ccToMe (optional) 是否抄送给我
     * @param current (optional) 当前页
     * @param excludeSubprocesses (optional) 是否包含子流程(初期忽略此字段)
     * @param finished (optional) 已办结
     * @param finishedAfter (optional) 结束时间范围(After)
     * @param finishedBefore (optional) 结束时间范围(Before)
     * @param involvedUser (optional) 参与用户
     * @param orderRule (optional) 排序规则：orderColumn|DESC,orderColumn|ASC
     * @param processDefinitionCategory (optional) 流程定义分类
     * @param processDefinitionId (optional) 流程定义ID
     * @param processDefinitionKey (optional) 流程定义Key
     * @param processDefinitionName (optional) 流程定义Name
     * @param processInstanceId (optional) 流程实例ID
     * @param processInstanceName (optional) 流程实例名称
     * @param size (optional) 分页大小
     * @param startedAfter (optional) 开始时间范围(After)
     * @param startedBefore (optional) 开始时间范围(Before)
     * @param startedBy (optional) 启动人
     * @param startedByMe (optional) 是否我发起得
     * @param superProcessInstanceId (optional) 子流程ID
     * @param tenantId (optional) 所属租户
     * @param unfinished (optional) 未办结
     * @param userId (optional) 用户Id
     * @return OK
     */
    listMyInvolvedSummary(businessKey: string | null | undefined, ccToMe: boolean | null | undefined, current: number | null | undefined, excludeSubprocesses: boolean | null | undefined, finished: boolean | null | undefined, finishedAfter: string | null | undefined, finishedBefore: string | null | undefined, involvedUser: string | null | undefined, orderRule: string | null | undefined, processDefinitionCategory: string | null | undefined, processDefinitionId: string | null | undefined, processDefinitionKey: string | null | undefined, processDefinitionName: string | null | undefined, processInstanceId: string | null | undefined, processInstanceName: string | null | undefined, size: number | null | undefined, startedAfter: string | null | undefined, startedBefore: string | null | undefined, startedBy: string | null | undefined, startedByMe: boolean | null | undefined, superProcessInstanceId: string | null | undefined, tenantId: string | null | undefined, unfinished: boolean | null | undefined, userId: string | null | undefined): Promise<CategoryVo[]> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.251:31080/blade-flow')+ "/flowable/processInstance/listMyInvolvedSummary?";
        if (businessKey !== undefined)
            url_ += "businessKey=" + encodeURIComponent("" + businessKey) + "&"; 
        if (ccToMe !== undefined)
            url_ += "ccToMe=" + encodeURIComponent("" + ccToMe) + "&"; 
        if (current !== undefined)
            url_ += "current=" + encodeURIComponent("" + current) + "&"; 
        if (excludeSubprocesses !== undefined)
            url_ += "excludeSubprocesses=" + encodeURIComponent("" + excludeSubprocesses) + "&"; 
        if (finished !== undefined)
            url_ += "finished=" + encodeURIComponent("" + finished) + "&"; 
        if (finishedAfter !== undefined)
            url_ += "finishedAfter=" + encodeURIComponent("" + finishedAfter) + "&"; 
        if (finishedBefore !== undefined)
            url_ += "finishedBefore=" + encodeURIComponent("" + finishedBefore) + "&"; 
        if (involvedUser !== undefined)
            url_ += "involvedUser=" + encodeURIComponent("" + involvedUser) + "&"; 
        if (orderRule !== undefined)
            url_ += "orderRule=" + encodeURIComponent("" + orderRule) + "&"; 
        if (processDefinitionCategory !== undefined)
            url_ += "processDefinitionCategory=" + encodeURIComponent("" + processDefinitionCategory) + "&"; 
        if (processDefinitionId !== undefined)
            url_ += "processDefinitionId=" + encodeURIComponent("" + processDefinitionId) + "&"; 
        if (processDefinitionKey !== undefined)
            url_ += "processDefinitionKey=" + encodeURIComponent("" + processDefinitionKey) + "&"; 
        if (processDefinitionName !== undefined)
            url_ += "processDefinitionName=" + encodeURIComponent("" + processDefinitionName) + "&"; 
        if (processInstanceId !== undefined)
            url_ += "processInstanceId=" + encodeURIComponent("" + processInstanceId) + "&"; 
        if (processInstanceName !== undefined)
            url_ += "processInstanceName=" + encodeURIComponent("" + processInstanceName) + "&"; 
        if (size !== undefined)
            url_ += "size=" + encodeURIComponent("" + size) + "&"; 
        if (startedAfter !== undefined)
            url_ += "startedAfter=" + encodeURIComponent("" + startedAfter) + "&"; 
        if (startedBefore !== undefined)
            url_ += "startedBefore=" + encodeURIComponent("" + startedBefore) + "&"; 
        if (startedBy !== undefined)
            url_ += "startedBy=" + encodeURIComponent("" + startedBy) + "&"; 
        if (startedByMe !== undefined)
            url_ += "startedByMe=" + encodeURIComponent("" + startedByMe) + "&"; 
        if (superProcessInstanceId !== undefined)
            url_ += "superProcessInstanceId=" + encodeURIComponent("" + superProcessInstanceId) + "&"; 
        if (tenantId !== undefined)
            url_ += "tenantId=" + encodeURIComponent("" + tenantId) + "&"; 
        if (unfinished !== undefined)
            url_ += "unfinished=" + encodeURIComponent("" + unfinished) + "&"; 
        if (userId !== undefined)
            url_ += "userId=" + encodeURIComponent("" + userId) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processListMyInvolvedSummary(_response);
        });
    }

    protected processListMyInvolvedSummary(response: AxiosResponse): Promise<CategoryVo[]> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            if (resultData200 && resultData200.constructor === Array) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(CategoryVo.fromJS(item));
            }
            return result200;
        }
        return Promise.resolve<CategoryVo[]>(<any>null);
    }

    /**
     * 查询我发起的流程实例
     * @param businessKey (optional) 业务主键KEY
     * @param ccToMe (optional) 是否抄送给我
     * @param current (optional) 当前页
     * @param excludeSubprocesses (optional) 是否包含子流程(初期忽略此字段)
     * @param finished (optional) 已办结
     * @param finishedAfter (optional) 结束时间范围(After)
     * @param finishedBefore (optional) 结束时间范围(Before)
     * @param involvedUser (optional) 参与用户
     * @param orderRule (optional) 排序规则：orderColumn|DESC,orderColumn|ASC
     * @param processDefinitionCategory (optional) 流程定义分类
     * @param processDefinitionId (optional) 流程定义ID
     * @param processDefinitionKey (optional) 流程定义Key
     * @param processDefinitionName (optional) 流程定义Name
     * @param processInstanceId (optional) 流程实例ID
     * @param processInstanceName (optional) 流程实例名称
     * @param size (optional) 分页大小
     * @param startedAfter (optional) 开始时间范围(After)
     * @param startedBefore (optional) 开始时间范围(Before)
     * @param startedBy (optional) 启动人
     * @param startedByMe (optional) 是否我发起得
     * @param superProcessInstanceId (optional) 子流程ID
     * @param tenantId (optional) 所属租户
     * @param unfinished (optional) 未办结
     * @param userId (optional) 用户Id
     * @return OK
     */
    listStartedByMe(businessKey: string | null | undefined, ccToMe: boolean | null | undefined, current: number | null | undefined, excludeSubprocesses: boolean | null | undefined, finished: boolean | null | undefined, finishedAfter: string | null | undefined, finishedBefore: string | null | undefined, involvedUser: string | null | undefined, orderRule: string | null | undefined, processDefinitionCategory: string | null | undefined, processDefinitionId: string | null | undefined, processDefinitionKey: string | null | undefined, processDefinitionName: string | null | undefined, processInstanceId: string | null | undefined, processInstanceName: string | null | undefined, size: number | null | undefined, startedAfter: string | null | undefined, startedBefore: string | null | undefined, startedBy: string | null | undefined, startedByMe: boolean | null | undefined, superProcessInstanceId: string | null | undefined, tenantId: string | null | undefined, unfinished: boolean | null | undefined, userId: string | null | undefined): Promise<FlowablePage> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.251:31080/blade-flow')+ "/flowable/processInstance/listStartedByMe?";
        if (businessKey !== undefined)
            url_ += "businessKey=" + encodeURIComponent("" + businessKey) + "&"; 
        if (ccToMe !== undefined)
            url_ += "ccToMe=" + encodeURIComponent("" + ccToMe) + "&"; 
        if (current !== undefined)
            url_ += "current=" + encodeURIComponent("" + current) + "&"; 
        if (excludeSubprocesses !== undefined)
            url_ += "excludeSubprocesses=" + encodeURIComponent("" + excludeSubprocesses) + "&"; 
        if (finished !== undefined)
            url_ += "finished=" + encodeURIComponent("" + finished) + "&"; 
        if (finishedAfter !== undefined)
            url_ += "finishedAfter=" + encodeURIComponent("" + finishedAfter) + "&"; 
        if (finishedBefore !== undefined)
            url_ += "finishedBefore=" + encodeURIComponent("" + finishedBefore) + "&"; 
        if (involvedUser !== undefined)
            url_ += "involvedUser=" + encodeURIComponent("" + involvedUser) + "&"; 
        if (orderRule !== undefined)
            url_ += "orderRule=" + encodeURIComponent("" + orderRule) + "&"; 
        if (processDefinitionCategory !== undefined)
            url_ += "processDefinitionCategory=" + encodeURIComponent("" + processDefinitionCategory) + "&"; 
        if (processDefinitionId !== undefined)
            url_ += "processDefinitionId=" + encodeURIComponent("" + processDefinitionId) + "&"; 
        if (processDefinitionKey !== undefined)
            url_ += "processDefinitionKey=" + encodeURIComponent("" + processDefinitionKey) + "&"; 
        if (processDefinitionName !== undefined)
            url_ += "processDefinitionName=" + encodeURIComponent("" + processDefinitionName) + "&"; 
        if (processInstanceId !== undefined)
            url_ += "processInstanceId=" + encodeURIComponent("" + processInstanceId) + "&"; 
        if (processInstanceName !== undefined)
            url_ += "processInstanceName=" + encodeURIComponent("" + processInstanceName) + "&"; 
        if (size !== undefined)
            url_ += "size=" + encodeURIComponent("" + size) + "&"; 
        if (startedAfter !== undefined)
            url_ += "startedAfter=" + encodeURIComponent("" + startedAfter) + "&"; 
        if (startedBefore !== undefined)
            url_ += "startedBefore=" + encodeURIComponent("" + startedBefore) + "&"; 
        if (startedBy !== undefined)
            url_ += "startedBy=" + encodeURIComponent("" + startedBy) + "&"; 
        if (startedByMe !== undefined)
            url_ += "startedByMe=" + encodeURIComponent("" + startedByMe) + "&"; 
        if (superProcessInstanceId !== undefined)
            url_ += "superProcessInstanceId=" + encodeURIComponent("" + superProcessInstanceId) + "&"; 
        if (tenantId !== undefined)
            url_ += "tenantId=" + encodeURIComponent("" + tenantId) + "&"; 
        if (unfinished !== undefined)
            url_ += "unfinished=" + encodeURIComponent("" + unfinished) + "&"; 
        if (userId !== undefined)
            url_ += "userId=" + encodeURIComponent("" + userId) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processListStartedByMe(_response);
        });
    }

    protected processListStartedByMe(response: AxiosResponse): Promise<FlowablePage> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 ? FlowablePage.fromJS(resultData200) : new FlowablePage();
            return result200;
        }
        return Promise.resolve<FlowablePage>(<any>null);
    }

    /**
     * 根据ID查询流程实例
     * @param processInstanceId (optional) 流程实例ID
     * @return OK
     */
    queryById(processInstanceId: string | null | undefined): Promise<ProcessInstanceDetailResponse> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.251:31080/blade-flow')+ "/flowable/processInstance/queryById?";
        if (processInstanceId !== undefined)
            url_ += "processInstanceId=" + encodeURIComponent("" + processInstanceId) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processQueryById(_response);
        });
    }

    protected processQueryById(response: AxiosResponse): Promise<ProcessInstanceDetailResponse> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 ? ProcessInstanceDetailResponse.fromJS(resultData200) : new ProcessInstanceDetailResponse();
            return result200;
        }
        return Promise.resolve<ProcessInstanceDetailResponse>(<any>null);
    }

    /**
     * 启动流程实例
     * @param processInstanceRequest processInstanceRequest
     * @return OK
     */
    start(processInstanceRequest: ProcessInstanceRequest): Promise<void> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.251:31080/blade-flow')+ "/flowable/processInstance/start";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(processInstanceRequest);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json", 
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processStart(_response);
        });
    }

    protected processStart(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            return Promise.resolve<void>(<any>null);
        }
        return Promise.resolve<void>(<any>null);
    }

    /**
     * 挂起流程实例
     * @param processInstanceRequest processInstanceRequest
     * @return OK
     */
    suspend(processInstanceRequest: ProcessInstanceRequest): Promise<void> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.251:31080/blade-flow')+ "/flowable/processInstance/suspend";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(processInstanceRequest);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json", 
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processSuspend(_response);
        });
    }

    protected processSuspend(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            return Promise.resolve<void>(<any>null);
        }
        return Promise.resolve<void>(<any>null);
    }
}

export class ProcessInstanceImageServiceProxy extends AbpServiceBase {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor() {
        super();
        this.instance = this.ajax;
        this.baseUrl = this.ajaxBaseUrl;
    }

    /**
     * 查询流程实例流程进行图
     * @param processInstanceId (optional) 流程实例ID
     * @return OK
     */
    image(processInstanceId: string | null | undefined): Promise<string> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.251:31080/blade-flow')+ "/flowable/processInstanceImage?";
        if (processInstanceId !== undefined)
            url_ += "processInstanceId=" + encodeURIComponent("" + processInstanceId) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processImage(_response);
        });
    }

    protected processImage(response: AxiosResponse): Promise<string> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return result200;
        }
        return Promise.resolve<string>(<any>null);
    }
}

export class TaskServiceProxy extends AbpServiceBase {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor() {
        super();
        this.instance = this.ajax;
        this.baseUrl = this.ajaxBaseUrl;
    }

    /**
     * 转办任务
     * @param taskRequest taskRequest
     * @return OK
     */
    assign(taskRequest: TaskRequest): Promise<void> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.251:31080/blade-flow')+ "/flowable/task/assign";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(taskRequest);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json", 
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processAssign(_response);
        });
    }

    protected processAssign(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            return Promise.resolve<void>(<any>null);
        }
        return Promise.resolve<void>(<any>null);
    }

    /**
     * 退回任务
     * @param taskRequest taskRequest
     * @return OK
     */
    back(taskRequest: TaskRequest): Promise<void> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.251:31080/blade-flow')+ "/flowable/task/back";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(taskRequest);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json", 
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processBack(_response);
        });
    }

    protected processBack(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            return Promise.resolve<void>(<any>null);
        }
        return Promise.resolve<void>(<any>null);
    }

    /**
     * 查看任务可回退的节点
     * @param taskId taskId
     * @return OK
     */
    backNodes(taskId: string): Promise<FlowNodeResponse[]> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.251:31080/blade-flow')+ "/flowable/task/backNodes?";
        if (taskId === undefined || taskId === null)
            throw new Error("The parameter 'taskId' must be defined and cannot be null.");
        else
            url_ += "taskId=" + encodeURIComponent("" + taskId) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processBackNodes(_response);
        });
    }

    protected processBackNodes(response: AxiosResponse): Promise<FlowNodeResponse[]> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            if (resultData200 && resultData200.constructor === Array) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(FlowNodeResponse.fromJS(item));
            }
            return result200;
        }
        return Promise.resolve<FlowNodeResponse[]>(<any>null);
    }

    /**
     * 认领任务
     * @param taskRequest taskRequest
     * @return OK
     */
    claim(taskRequest: TaskRequest): Promise<void> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.251:31080/blade-flow')+ "/flowable/task/claim";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(taskRequest);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json", 
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processClaim(_response);
        });
    }

    protected processClaim(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            return Promise.resolve<void>(<any>null);
        }
        return Promise.resolve<void>(<any>null);
    }

    /**
     * 完成任务
     * @param taskRequest taskRequest
     * @return OK
     */
    complete(taskRequest: TaskRequest): Promise<void> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.251:31080/blade-flow')+ "/flowable/task/complete";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(taskRequest);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json", 
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processComplete(_response);
        });
    }

    protected processComplete(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            return Promise.resolve<void>(<any>null);
        }
        return Promise.resolve<void>(<any>null);
    }

    /**
     * 委派任务
     * @param taskRequest taskRequest
     * @return OK
     */
    delegate(taskRequest: TaskRequest): Promise<void> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.251:31080/blade-flow')+ "/flowable/task/delegate";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(taskRequest);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json", 
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processDelegate(_response);
        });
    }

    protected processDelegate(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            return Promise.resolve<void>(<any>null);
        }
        return Promise.resolve<void>(<any>null);
    }

    /**
     * 删除任务
     * @param taskId (optional) 任务ID
     * @return OK
     */
    delete(taskId: string | null | undefined): Promise<void> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.251:31080/blade-flow')+ "/flowable/task/delete?";
        if (taskId !== undefined)
            url_ += "taskId=" + encodeURIComponent("" + taskId) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "DELETE",
            url: url_,
            headers: {
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processDelete(_response);
        });
    }

    protected processDelete(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            return Promise.resolve<void>(<any>null);
        }
        return Promise.resolve<void>(<any>null);
    }

    /**
     * 获取任务数据
     * @param taskId taskId
     * @return OK
     */
    executeTaskData(taskId: string): Promise<ExecuteTaskDataVo> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.251:31080/blade-flow')+ "/flowable/task/executeTaskData?";
        if (taskId === undefined || taskId === null)
            throw new Error("The parameter 'taskId' must be defined and cannot be null.");
        else
            url_ += "taskId=" + encodeURIComponent("" + taskId) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processExecuteTaskData(_response);
        });
    }

    protected processExecuteTaskData(response: AxiosResponse): Promise<ExecuteTaskDataVo> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 ? ExecuteTaskDataVo.fromJS(resultData200) : new ExecuteTaskDataVo();
            return result200;
        }
        return Promise.resolve<ExecuteTaskDataVo>(<any>null);
    }

    /**
     * 任务列表
     * @param active (optional) 任务分类
     * @param current (optional) 当前页
     * @param executionId (optional) 执行ID
     * @param finished (optional) 办结
     * @param orderRule (optional) 排序规则：orderColumn|DESC,orderColumn|ASC
     * @param processCategoryIn (optional) 流程分类IN
     * @param processCategoryNotIn (optional) 流程分类NOTIN
     * @param processDefinitionId (optional) 流程定义ID
     * @param processDefinitionKey (optional) 流程定义Key
     * @param processDefinitionName (optional) 流程定义名称
     * @param processFinished (optional) 办结
     * @param processInstanceBusinessKey (optional) 流程实例业务主键Key
     * @param processInstanceId (optional) 流程实例ID
     * @param processInstanceName (optional) 流程实例名称
     * @param processUnfinished (optional) 未办结
     * @param size (optional) 分页大小
     * @param suspended (optional) 任务分类
     * @param taskAssignee (optional) 任务执行人
     * @param taskCandidateGroup (optional) 任务候选组
     * @param taskCandidateGroupIn (optional) 任务候选组IN
     * @param taskCandidateUser (optional) 任务候选人
     * @param taskCategory (optional) 任务分类
     * @param taskCompletedAfter (optional) 任务分类
     * @param taskCompletedBefore (optional) 任务分类
     * @param taskCreatedAfter (optional) 任务分类
     * @param taskCreatedBefore (optional) 任务分类
     * @param taskDefinitionKey (optional) 任务key
     * @param taskDescription (optional) 任务描述
     * @param taskDueAfter (optional) 任务分类
     * @param taskDueBefore (optional) 任务分类
     * @param taskId (optional) 任务ID
     * @param taskInvolvedUser (optional) 任务干系人
     * @param taskName (optional) 任务名称
     * @param taskOwner (optional) 任务所有人
     * @param taskParentTaskId (optional) 父任务ID
     * @param taskPriority (optional) 任务优先级
     * @param tenantId (optional) 所属租户
     * @param unfinished (optional) 未办结
     * @param userId (optional) 用户Id
     * @return OK
     */
    list(active: boolean | null | undefined, current: number | null | undefined, executionId: string | null | undefined, finished: boolean | null | undefined, orderRule: string | null | undefined, processCategoryIn: string | null | undefined, processCategoryNotIn: string | null | undefined, processDefinitionId: string | null | undefined, processDefinitionKey: string | null | undefined, processDefinitionName: string | null | undefined, processFinished: boolean | null | undefined, processInstanceBusinessKey: string | null | undefined, processInstanceId: string | null | undefined, processInstanceName: string | null | undefined, processUnfinished: boolean | null | undefined, size: number | null | undefined, suspended: boolean | null | undefined, taskAssignee: string | null | undefined, taskCandidateGroup: string | null | undefined, taskCandidateGroupIn: string | null | undefined, taskCandidateUser: string | null | undefined, taskCategory: string | null | undefined, taskCompletedAfter: string | null | undefined, taskCompletedBefore: string | null | undefined, taskCreatedAfter: string | null | undefined, taskCreatedBefore: string | null | undefined, taskDefinitionKey: string | null | undefined, taskDescription: string | null | undefined, taskDueAfter: string | null | undefined, taskDueBefore: string | null | undefined, taskId: string | null | undefined, taskInvolvedUser: string | null | undefined, taskName: string | null | undefined, taskOwner: string | null | undefined, taskParentTaskId: string | null | undefined, taskPriority: number | null | undefined, tenantId: string | null | undefined, unfinished: boolean | null | undefined, userId: string | null | undefined): Promise<FlowablePage> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.251:31080/blade-flow')+ "/flowable/task/list?";
        if (active !== undefined)
            url_ += "active=" + encodeURIComponent("" + active) + "&"; 
        if (current !== undefined)
            url_ += "current=" + encodeURIComponent("" + current) + "&"; 
        if (executionId !== undefined)
            url_ += "executionId=" + encodeURIComponent("" + executionId) + "&"; 
        if (finished !== undefined)
            url_ += "finished=" + encodeURIComponent("" + finished) + "&"; 
        if (orderRule !== undefined)
            url_ += "orderRule=" + encodeURIComponent("" + orderRule) + "&"; 
        if (processCategoryIn !== undefined)
            url_ += "processCategoryIn=" + encodeURIComponent("" + processCategoryIn) + "&"; 
        if (processCategoryNotIn !== undefined)
            url_ += "processCategoryNotIn=" + encodeURIComponent("" + processCategoryNotIn) + "&"; 
        if (processDefinitionId !== undefined)
            url_ += "processDefinitionId=" + encodeURIComponent("" + processDefinitionId) + "&"; 
        if (processDefinitionKey !== undefined)
            url_ += "processDefinitionKey=" + encodeURIComponent("" + processDefinitionKey) + "&"; 
        if (processDefinitionName !== undefined)
            url_ += "processDefinitionName=" + encodeURIComponent("" + processDefinitionName) + "&"; 
        if (processFinished !== undefined)
            url_ += "processFinished=" + encodeURIComponent("" + processFinished) + "&"; 
        if (processInstanceBusinessKey !== undefined)
            url_ += "processInstanceBusinessKey=" + encodeURIComponent("" + processInstanceBusinessKey) + "&"; 
        if (processInstanceId !== undefined)
            url_ += "processInstanceId=" + encodeURIComponent("" + processInstanceId) + "&"; 
        if (processInstanceName !== undefined)
            url_ += "processInstanceName=" + encodeURIComponent("" + processInstanceName) + "&"; 
        if (processUnfinished !== undefined)
            url_ += "processUnfinished=" + encodeURIComponent("" + processUnfinished) + "&"; 
        if (size !== undefined)
            url_ += "size=" + encodeURIComponent("" + size) + "&"; 
        if (suspended !== undefined)
            url_ += "suspended=" + encodeURIComponent("" + suspended) + "&"; 
        if (taskAssignee !== undefined)
            url_ += "taskAssignee=" + encodeURIComponent("" + taskAssignee) + "&"; 
        if (taskCandidateGroup !== undefined)
            url_ += "taskCandidateGroup=" + encodeURIComponent("" + taskCandidateGroup) + "&"; 
        if (taskCandidateGroupIn !== undefined)
            url_ += "taskCandidateGroupIn=" + encodeURIComponent("" + taskCandidateGroupIn) + "&"; 
        if (taskCandidateUser !== undefined)
            url_ += "taskCandidateUser=" + encodeURIComponent("" + taskCandidateUser) + "&"; 
        if (taskCategory !== undefined)
            url_ += "taskCategory=" + encodeURIComponent("" + taskCategory) + "&"; 
        if (taskCompletedAfter !== undefined)
            url_ += "taskCompletedAfter=" + encodeURIComponent("" + taskCompletedAfter) + "&"; 
        if (taskCompletedBefore !== undefined)
            url_ += "taskCompletedBefore=" + encodeURIComponent("" + taskCompletedBefore) + "&"; 
        if (taskCreatedAfter !== undefined)
            url_ += "taskCreatedAfter=" + encodeURIComponent("" + taskCreatedAfter) + "&"; 
        if (taskCreatedBefore !== undefined)
            url_ += "taskCreatedBefore=" + encodeURIComponent("" + taskCreatedBefore) + "&"; 
        if (taskDefinitionKey !== undefined)
            url_ += "taskDefinitionKey=" + encodeURIComponent("" + taskDefinitionKey) + "&"; 
        if (taskDescription !== undefined)
            url_ += "taskDescription=" + encodeURIComponent("" + taskDescription) + "&"; 
        if (taskDueAfter !== undefined)
            url_ += "taskDueAfter=" + encodeURIComponent("" + taskDueAfter) + "&"; 
        if (taskDueBefore !== undefined)
            url_ += "taskDueBefore=" + encodeURIComponent("" + taskDueBefore) + "&"; 
        if (taskId !== undefined)
            url_ += "taskId=" + encodeURIComponent("" + taskId) + "&"; 
        if (taskInvolvedUser !== undefined)
            url_ += "taskInvolvedUser=" + encodeURIComponent("" + taskInvolvedUser) + "&"; 
        if (taskName !== undefined)
            url_ += "taskName=" + encodeURIComponent("" + taskName) + "&"; 
        if (taskOwner !== undefined)
            url_ += "taskOwner=" + encodeURIComponent("" + taskOwner) + "&"; 
        if (taskParentTaskId !== undefined)
            url_ += "taskParentTaskId=" + encodeURIComponent("" + taskParentTaskId) + "&"; 
        if (taskPriority !== undefined)
            url_ += "taskPriority=" + encodeURIComponent("" + taskPriority) + "&"; 
        if (tenantId !== undefined)
            url_ += "tenantId=" + encodeURIComponent("" + tenantId) + "&"; 
        if (unfinished !== undefined)
            url_ += "unfinished=" + encodeURIComponent("" + unfinished) + "&"; 
        if (userId !== undefined)
            url_ += "userId=" + encodeURIComponent("" + userId) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processList(_response);
        });
    }

    protected processList(response: AxiosResponse): Promise<FlowablePage> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 ? FlowablePage.fromJS(resultData200) : new FlowablePage();
            return result200;
        }
        return Promise.resolve<FlowablePage>(<any>null);
    }

    /**
     * 我的已办
     * @param active (optional) 任务分类
     * @param current (optional) 当前页
     * @param executionId (optional) 执行ID
     * @param finished (optional) 办结
     * @param orderRule (optional) 排序规则：orderColumn|DESC,orderColumn|ASC
     * @param processCategoryIn (optional) 流程分类IN
     * @param processCategoryNotIn (optional) 流程分类NOTIN
     * @param processDefinitionId (optional) 流程定义ID
     * @param processDefinitionKey (optional) 流程定义Key
     * @param processDefinitionName (optional) 流程定义名称
     * @param processFinished (optional) 办结
     * @param processInstanceBusinessKey (optional) 流程实例业务主键Key
     * @param processInstanceId (optional) 流程实例ID
     * @param processInstanceName (optional) 流程实例名称
     * @param processUnfinished (optional) 未办结
     * @param size (optional) 分页大小
     * @param suspended (optional) 任务分类
     * @param taskAssignee (optional) 任务执行人
     * @param taskCandidateGroup (optional) 任务候选组
     * @param taskCandidateGroupIn (optional) 任务候选组IN
     * @param taskCandidateUser (optional) 任务候选人
     * @param taskCategory (optional) 任务分类
     * @param taskCompletedAfter (optional) 任务分类
     * @param taskCompletedBefore (optional) 任务分类
     * @param taskCreatedAfter (optional) 任务分类
     * @param taskCreatedBefore (optional) 任务分类
     * @param taskDefinitionKey (optional) 任务key
     * @param taskDescription (optional) 任务描述
     * @param taskDueAfter (optional) 任务分类
     * @param taskDueBefore (optional) 任务分类
     * @param taskId (optional) 任务ID
     * @param taskInvolvedUser (optional) 任务干系人
     * @param taskName (optional) 任务名称
     * @param taskOwner (optional) 任务所有人
     * @param taskParentTaskId (optional) 父任务ID
     * @param taskPriority (optional) 任务优先级
     * @param tenantId (optional) 所属租户
     * @param unfinished (optional) 未办结
     * @param userId (optional) 用户Id
     * @return OK
     */
    listDone(active: boolean | null | undefined, current: number | null | undefined, executionId: string | null | undefined, finished: boolean | null | undefined, orderRule: string | null | undefined, processCategoryIn: string | null | undefined, processCategoryNotIn: string | null | undefined, processDefinitionId: string | null | undefined, processDefinitionKey: string | null | undefined, processDefinitionName: string | null | undefined, processFinished: boolean | null | undefined, processInstanceBusinessKey: string | null | undefined, processInstanceId: string | null | undefined, processInstanceName: string | null | undefined, processUnfinished: boolean | null | undefined, size: number | null | undefined, suspended: boolean | null | undefined, taskAssignee: string | null | undefined, taskCandidateGroup: string | null | undefined, taskCandidateGroupIn: string | null | undefined, taskCandidateUser: string | null | undefined, taskCategory: string | null | undefined, taskCompletedAfter: string | null | undefined, taskCompletedBefore: string | null | undefined, taskCreatedAfter: string | null | undefined, taskCreatedBefore: string | null | undefined, taskDefinitionKey: string | null | undefined, taskDescription: string | null | undefined, taskDueAfter: string | null | undefined, taskDueBefore: string | null | undefined, taskId: string | null | undefined, taskInvolvedUser: string | null | undefined, taskName: string | null | undefined, taskOwner: string | null | undefined, taskParentTaskId: string | null | undefined, taskPriority: number | null | undefined, tenantId: string | null | undefined, unfinished: boolean | null | undefined, userId: string | null | undefined): Promise<FlowablePage> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.251:31080/blade-flow')+ "/flowable/task/listDone?";
        if (active !== undefined)
            url_ += "active=" + encodeURIComponent("" + active) + "&"; 
        if (current !== undefined)
            url_ += "current=" + encodeURIComponent("" + current) + "&"; 
        if (executionId !== undefined)
            url_ += "executionId=" + encodeURIComponent("" + executionId) + "&"; 
        if (finished !== undefined)
            url_ += "finished=" + encodeURIComponent("" + finished) + "&"; 
        if (orderRule !== undefined)
            url_ += "orderRule=" + encodeURIComponent("" + orderRule) + "&"; 
        if (processCategoryIn !== undefined)
            url_ += "processCategoryIn=" + encodeURIComponent("" + processCategoryIn) + "&"; 
        if (processCategoryNotIn !== undefined)
            url_ += "processCategoryNotIn=" + encodeURIComponent("" + processCategoryNotIn) + "&"; 
        if (processDefinitionId !== undefined)
            url_ += "processDefinitionId=" + encodeURIComponent("" + processDefinitionId) + "&"; 
        if (processDefinitionKey !== undefined)
            url_ += "processDefinitionKey=" + encodeURIComponent("" + processDefinitionKey) + "&"; 
        if (processDefinitionName !== undefined)
            url_ += "processDefinitionName=" + encodeURIComponent("" + processDefinitionName) + "&"; 
        if (processFinished !== undefined)
            url_ += "processFinished=" + encodeURIComponent("" + processFinished) + "&"; 
        if (processInstanceBusinessKey !== undefined)
            url_ += "processInstanceBusinessKey=" + encodeURIComponent("" + processInstanceBusinessKey) + "&"; 
        if (processInstanceId !== undefined)
            url_ += "processInstanceId=" + encodeURIComponent("" + processInstanceId) + "&"; 
        if (processInstanceName !== undefined)
            url_ += "processInstanceName=" + encodeURIComponent("" + processInstanceName) + "&"; 
        if (processUnfinished !== undefined)
            url_ += "processUnfinished=" + encodeURIComponent("" + processUnfinished) + "&"; 
        if (size !== undefined)
            url_ += "size=" + encodeURIComponent("" + size) + "&"; 
        if (suspended !== undefined)
            url_ += "suspended=" + encodeURIComponent("" + suspended) + "&"; 
        if (taskAssignee !== undefined)
            url_ += "taskAssignee=" + encodeURIComponent("" + taskAssignee) + "&"; 
        if (taskCandidateGroup !== undefined)
            url_ += "taskCandidateGroup=" + encodeURIComponent("" + taskCandidateGroup) + "&"; 
        if (taskCandidateGroupIn !== undefined)
            url_ += "taskCandidateGroupIn=" + encodeURIComponent("" + taskCandidateGroupIn) + "&"; 
        if (taskCandidateUser !== undefined)
            url_ += "taskCandidateUser=" + encodeURIComponent("" + taskCandidateUser) + "&"; 
        if (taskCategory !== undefined)
            url_ += "taskCategory=" + encodeURIComponent("" + taskCategory) + "&"; 
        if (taskCompletedAfter !== undefined)
            url_ += "taskCompletedAfter=" + encodeURIComponent("" + taskCompletedAfter) + "&"; 
        if (taskCompletedBefore !== undefined)
            url_ += "taskCompletedBefore=" + encodeURIComponent("" + taskCompletedBefore) + "&"; 
        if (taskCreatedAfter !== undefined)
            url_ += "taskCreatedAfter=" + encodeURIComponent("" + taskCreatedAfter) + "&"; 
        if (taskCreatedBefore !== undefined)
            url_ += "taskCreatedBefore=" + encodeURIComponent("" + taskCreatedBefore) + "&"; 
        if (taskDefinitionKey !== undefined)
            url_ += "taskDefinitionKey=" + encodeURIComponent("" + taskDefinitionKey) + "&"; 
        if (taskDescription !== undefined)
            url_ += "taskDescription=" + encodeURIComponent("" + taskDescription) + "&"; 
        if (taskDueAfter !== undefined)
            url_ += "taskDueAfter=" + encodeURIComponent("" + taskDueAfter) + "&"; 
        if (taskDueBefore !== undefined)
            url_ += "taskDueBefore=" + encodeURIComponent("" + taskDueBefore) + "&"; 
        if (taskId !== undefined)
            url_ += "taskId=" + encodeURIComponent("" + taskId) + "&"; 
        if (taskInvolvedUser !== undefined)
            url_ += "taskInvolvedUser=" + encodeURIComponent("" + taskInvolvedUser) + "&"; 
        if (taskName !== undefined)
            url_ += "taskName=" + encodeURIComponent("" + taskName) + "&"; 
        if (taskOwner !== undefined)
            url_ += "taskOwner=" + encodeURIComponent("" + taskOwner) + "&"; 
        if (taskParentTaskId !== undefined)
            url_ += "taskParentTaskId=" + encodeURIComponent("" + taskParentTaskId) + "&"; 
        if (taskPriority !== undefined)
            url_ += "taskPriority=" + encodeURIComponent("" + taskPriority) + "&"; 
        if (tenantId !== undefined)
            url_ += "tenantId=" + encodeURIComponent("" + tenantId) + "&"; 
        if (unfinished !== undefined)
            url_ += "unfinished=" + encodeURIComponent("" + unfinished) + "&"; 
        if (userId !== undefined)
            url_ += "userId=" + encodeURIComponent("" + userId) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processListDone(_response);
        });
    }

    protected processListDone(response: AxiosResponse): Promise<FlowablePage> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 ? FlowablePage.fromJS(resultData200) : new FlowablePage();
            return result200;
        }
        return Promise.resolve<FlowablePage>(<any>null);
    }

    /**
     * 我的待阅
     * @param active (optional) 任务分类
     * @param current (optional) 当前页
     * @param executionId (optional) 执行ID
     * @param finished (optional) 办结
     * @param orderRule (optional) 排序规则：orderColumn|DESC,orderColumn|ASC
     * @param processCategoryIn (optional) 流程分类IN
     * @param processCategoryNotIn (optional) 流程分类NOTIN
     * @param processDefinitionId (optional) 流程定义ID
     * @param processDefinitionKey (optional) 流程定义Key
     * @param processDefinitionName (optional) 流程定义名称
     * @param processFinished (optional) 办结
     * @param processInstanceBusinessKey (optional) 流程实例业务主键Key
     * @param processInstanceId (optional) 流程实例ID
     * @param processInstanceName (optional) 流程实例名称
     * @param processUnfinished (optional) 未办结
     * @param size (optional) 分页大小
     * @param suspended (optional) 任务分类
     * @param taskAssignee (optional) 任务执行人
     * @param taskCandidateGroup (optional) 任务候选组
     * @param taskCandidateGroupIn (optional) 任务候选组IN
     * @param taskCandidateUser (optional) 任务候选人
     * @param taskCategory (optional) 任务分类
     * @param taskCompletedAfter (optional) 任务分类
     * @param taskCompletedBefore (optional) 任务分类
     * @param taskCreatedAfter (optional) 任务分类
     * @param taskCreatedBefore (optional) 任务分类
     * @param taskDefinitionKey (optional) 任务key
     * @param taskDescription (optional) 任务描述
     * @param taskDueAfter (optional) 任务分类
     * @param taskDueBefore (optional) 任务分类
     * @param taskId (optional) 任务ID
     * @param taskInvolvedUser (optional) 任务干系人
     * @param taskName (optional) 任务名称
     * @param taskOwner (optional) 任务所有人
     * @param taskParentTaskId (optional) 父任务ID
     * @param taskPriority (optional) 任务优先级
     * @param tenantId (optional) 所属租户
     * @param unfinished (optional) 未办结
     * @param userId (optional) 用户Id
     * @return OK
     */
    listToRead(active: boolean | null | undefined, current: number | null | undefined, executionId: string | null | undefined, finished: boolean | null | undefined, orderRule: string | null | undefined, processCategoryIn: string | null | undefined, processCategoryNotIn: string | null | undefined, processDefinitionId: string | null | undefined, processDefinitionKey: string | null | undefined, processDefinitionName: string | null | undefined, processFinished: boolean | null | undefined, processInstanceBusinessKey: string | null | undefined, processInstanceId: string | null | undefined, processInstanceName: string | null | undefined, processUnfinished: boolean | null | undefined, size: number | null | undefined, suspended: boolean | null | undefined, taskAssignee: string | null | undefined, taskCandidateGroup: string | null | undefined, taskCandidateGroupIn: string | null | undefined, taskCandidateUser: string | null | undefined, taskCategory: string | null | undefined, taskCompletedAfter: string | null | undefined, taskCompletedBefore: string | null | undefined, taskCreatedAfter: string | null | undefined, taskCreatedBefore: string | null | undefined, taskDefinitionKey: string | null | undefined, taskDescription: string | null | undefined, taskDueAfter: string | null | undefined, taskDueBefore: string | null | undefined, taskId: string | null | undefined, taskInvolvedUser: string | null | undefined, taskName: string | null | undefined, taskOwner: string | null | undefined, taskParentTaskId: string | null | undefined, taskPriority: number | null | undefined, tenantId: string | null | undefined, unfinished: boolean | null | undefined, userId: string | null | undefined): Promise<FlowablePage> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.251:31080/blade-flow')+ "/flowable/task/listToRead?";
        if (active !== undefined)
            url_ += "active=" + encodeURIComponent("" + active) + "&"; 
        if (current !== undefined)
            url_ += "current=" + encodeURIComponent("" + current) + "&"; 
        if (executionId !== undefined)
            url_ += "executionId=" + encodeURIComponent("" + executionId) + "&"; 
        if (finished !== undefined)
            url_ += "finished=" + encodeURIComponent("" + finished) + "&"; 
        if (orderRule !== undefined)
            url_ += "orderRule=" + encodeURIComponent("" + orderRule) + "&"; 
        if (processCategoryIn !== undefined)
            url_ += "processCategoryIn=" + encodeURIComponent("" + processCategoryIn) + "&"; 
        if (processCategoryNotIn !== undefined)
            url_ += "processCategoryNotIn=" + encodeURIComponent("" + processCategoryNotIn) + "&"; 
        if (processDefinitionId !== undefined)
            url_ += "processDefinitionId=" + encodeURIComponent("" + processDefinitionId) + "&"; 
        if (processDefinitionKey !== undefined)
            url_ += "processDefinitionKey=" + encodeURIComponent("" + processDefinitionKey) + "&"; 
        if (processDefinitionName !== undefined)
            url_ += "processDefinitionName=" + encodeURIComponent("" + processDefinitionName) + "&"; 
        if (processFinished !== undefined)
            url_ += "processFinished=" + encodeURIComponent("" + processFinished) + "&"; 
        if (processInstanceBusinessKey !== undefined)
            url_ += "processInstanceBusinessKey=" + encodeURIComponent("" + processInstanceBusinessKey) + "&"; 
        if (processInstanceId !== undefined)
            url_ += "processInstanceId=" + encodeURIComponent("" + processInstanceId) + "&"; 
        if (processInstanceName !== undefined)
            url_ += "processInstanceName=" + encodeURIComponent("" + processInstanceName) + "&"; 
        if (processUnfinished !== undefined)
            url_ += "processUnfinished=" + encodeURIComponent("" + processUnfinished) + "&"; 
        if (size !== undefined)
            url_ += "size=" + encodeURIComponent("" + size) + "&"; 
        if (suspended !== undefined)
            url_ += "suspended=" + encodeURIComponent("" + suspended) + "&"; 
        if (taskAssignee !== undefined)
            url_ += "taskAssignee=" + encodeURIComponent("" + taskAssignee) + "&"; 
        if (taskCandidateGroup !== undefined)
            url_ += "taskCandidateGroup=" + encodeURIComponent("" + taskCandidateGroup) + "&"; 
        if (taskCandidateGroupIn !== undefined)
            url_ += "taskCandidateGroupIn=" + encodeURIComponent("" + taskCandidateGroupIn) + "&"; 
        if (taskCandidateUser !== undefined)
            url_ += "taskCandidateUser=" + encodeURIComponent("" + taskCandidateUser) + "&"; 
        if (taskCategory !== undefined)
            url_ += "taskCategory=" + encodeURIComponent("" + taskCategory) + "&"; 
        if (taskCompletedAfter !== undefined)
            url_ += "taskCompletedAfter=" + encodeURIComponent("" + taskCompletedAfter) + "&"; 
        if (taskCompletedBefore !== undefined)
            url_ += "taskCompletedBefore=" + encodeURIComponent("" + taskCompletedBefore) + "&"; 
        if (taskCreatedAfter !== undefined)
            url_ += "taskCreatedAfter=" + encodeURIComponent("" + taskCreatedAfter) + "&"; 
        if (taskCreatedBefore !== undefined)
            url_ += "taskCreatedBefore=" + encodeURIComponent("" + taskCreatedBefore) + "&"; 
        if (taskDefinitionKey !== undefined)
            url_ += "taskDefinitionKey=" + encodeURIComponent("" + taskDefinitionKey) + "&"; 
        if (taskDescription !== undefined)
            url_ += "taskDescription=" + encodeURIComponent("" + taskDescription) + "&"; 
        if (taskDueAfter !== undefined)
            url_ += "taskDueAfter=" + encodeURIComponent("" + taskDueAfter) + "&"; 
        if (taskDueBefore !== undefined)
            url_ += "taskDueBefore=" + encodeURIComponent("" + taskDueBefore) + "&"; 
        if (taskId !== undefined)
            url_ += "taskId=" + encodeURIComponent("" + taskId) + "&"; 
        if (taskInvolvedUser !== undefined)
            url_ += "taskInvolvedUser=" + encodeURIComponent("" + taskInvolvedUser) + "&"; 
        if (taskName !== undefined)
            url_ += "taskName=" + encodeURIComponent("" + taskName) + "&"; 
        if (taskOwner !== undefined)
            url_ += "taskOwner=" + encodeURIComponent("" + taskOwner) + "&"; 
        if (taskParentTaskId !== undefined)
            url_ += "taskParentTaskId=" + encodeURIComponent("" + taskParentTaskId) + "&"; 
        if (taskPriority !== undefined)
            url_ += "taskPriority=" + encodeURIComponent("" + taskPriority) + "&"; 
        if (tenantId !== undefined)
            url_ += "tenantId=" + encodeURIComponent("" + tenantId) + "&"; 
        if (unfinished !== undefined)
            url_ += "unfinished=" + encodeURIComponent("" + unfinished) + "&"; 
        if (userId !== undefined)
            url_ += "userId=" + encodeURIComponent("" + userId) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processListToRead(_response);
        });
    }

    protected processListToRead(response: AxiosResponse): Promise<FlowablePage> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 ? FlowablePage.fromJS(resultData200) : new FlowablePage();
            return result200;
        }
        return Promise.resolve<FlowablePage>(<any>null);
    }

    /**
     * 我的待办
     * @param active (optional) 任务分类
     * @param current (optional) 当前页
     * @param executionId (optional) 执行ID
     * @param finished (optional) 办结
     * @param orderRule (optional) 排序规则：orderColumn|DESC,orderColumn|ASC
     * @param processCategoryIn (optional) 流程分类IN
     * @param processCategoryNotIn (optional) 流程分类NOTIN
     * @param processDefinitionId (optional) 流程定义ID
     * @param processDefinitionKey (optional) 流程定义Key
     * @param processDefinitionName (optional) 流程定义名称
     * @param processFinished (optional) 办结
     * @param processInstanceBusinessKey (optional) 流程实例业务主键Key
     * @param processInstanceId (optional) 流程实例ID
     * @param processInstanceName (optional) 流程实例名称
     * @param processUnfinished (optional) 未办结
     * @param size (optional) 分页大小
     * @param suspended (optional) 任务分类
     * @param taskAssignee (optional) 任务执行人
     * @param taskCandidateGroup (optional) 任务候选组
     * @param taskCandidateGroupIn (optional) 任务候选组IN
     * @param taskCandidateUser (optional) 任务候选人
     * @param taskCategory (optional) 任务分类
     * @param taskCompletedAfter (optional) 任务分类
     * @param taskCompletedBefore (optional) 任务分类
     * @param taskCreatedAfter (optional) 任务分类
     * @param taskCreatedBefore (optional) 任务分类
     * @param taskDefinitionKey (optional) 任务key
     * @param taskDescription (optional) 任务描述
     * @param taskDueAfter (optional) 任务分类
     * @param taskDueBefore (optional) 任务分类
     * @param taskId (optional) 任务ID
     * @param taskInvolvedUser (optional) 任务干系人
     * @param taskName (optional) 任务名称
     * @param taskOwner (optional) 任务所有人
     * @param taskParentTaskId (optional) 父任务ID
     * @param taskPriority (optional) 任务优先级
     * @param tenantId (optional) 所属租户
     * @param unfinished (optional) 未办结
     * @param userId (optional) 用户Id
     * @return OK
     */
    listTodo(active: boolean | null | undefined, current: number | null | undefined, executionId: string | null | undefined, finished: boolean | null | undefined, orderRule: string | null | undefined, processCategoryIn: string | null | undefined, processCategoryNotIn: string | null | undefined, processDefinitionId: string | null | undefined, processDefinitionKey: string | null | undefined, processDefinitionName: string | null | undefined, processFinished: boolean | null | undefined, processInstanceBusinessKey: string | null | undefined, processInstanceId: string | null | undefined, processInstanceName: string | null | undefined, processUnfinished: boolean | null | undefined, size: number | null | undefined, suspended: boolean | null | undefined, taskAssignee: string | null | undefined, taskCandidateGroup: string | null | undefined, taskCandidateGroupIn: string | null | undefined, taskCandidateUser: string | null | undefined, taskCategory: string | null | undefined, taskCompletedAfter: string | null | undefined, taskCompletedBefore: string | null | undefined, taskCreatedAfter: string | null | undefined, taskCreatedBefore: string | null | undefined, taskDefinitionKey: string | null | undefined, taskDescription: string | null | undefined, taskDueAfter: string | null | undefined, taskDueBefore: string | null | undefined, taskId: string | null | undefined, taskInvolvedUser: string | null | undefined, taskName: string | null | undefined, taskOwner: string | null | undefined, taskParentTaskId: string | null | undefined, taskPriority: number | null | undefined, tenantId: string | null | undefined, unfinished: boolean | null | undefined, userId: string | null | undefined): Promise<FlowablePage> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.251:31080/blade-flow')+ "/flowable/task/listTodo?";
        if (active !== undefined)
            url_ += "active=" + encodeURIComponent("" + active) + "&"; 
        if (current !== undefined)
            url_ += "current=" + encodeURIComponent("" + current) + "&"; 
        if (executionId !== undefined)
            url_ += "executionId=" + encodeURIComponent("" + executionId) + "&"; 
        if (finished !== undefined)
            url_ += "finished=" + encodeURIComponent("" + finished) + "&"; 
        if (orderRule !== undefined)
            url_ += "orderRule=" + encodeURIComponent("" + orderRule) + "&"; 
        if (processCategoryIn !== undefined)
            url_ += "processCategoryIn=" + encodeURIComponent("" + processCategoryIn) + "&"; 
        if (processCategoryNotIn !== undefined)
            url_ += "processCategoryNotIn=" + encodeURIComponent("" + processCategoryNotIn) + "&"; 
        if (processDefinitionId !== undefined)
            url_ += "processDefinitionId=" + encodeURIComponent("" + processDefinitionId) + "&"; 
        if (processDefinitionKey !== undefined)
            url_ += "processDefinitionKey=" + encodeURIComponent("" + processDefinitionKey) + "&"; 
        if (processDefinitionName !== undefined)
            url_ += "processDefinitionName=" + encodeURIComponent("" + processDefinitionName) + "&"; 
        if (processFinished !== undefined)
            url_ += "processFinished=" + encodeURIComponent("" + processFinished) + "&"; 
        if (processInstanceBusinessKey !== undefined)
            url_ += "processInstanceBusinessKey=" + encodeURIComponent("" + processInstanceBusinessKey) + "&"; 
        if (processInstanceId !== undefined)
            url_ += "processInstanceId=" + encodeURIComponent("" + processInstanceId) + "&"; 
        if (processInstanceName !== undefined)
            url_ += "processInstanceName=" + encodeURIComponent("" + processInstanceName) + "&"; 
        if (processUnfinished !== undefined)
            url_ += "processUnfinished=" + encodeURIComponent("" + processUnfinished) + "&"; 
        if (size !== undefined)
            url_ += "size=" + encodeURIComponent("" + size) + "&"; 
        if (suspended !== undefined)
            url_ += "suspended=" + encodeURIComponent("" + suspended) + "&"; 
        if (taskAssignee !== undefined)
            url_ += "taskAssignee=" + encodeURIComponent("" + taskAssignee) + "&"; 
        if (taskCandidateGroup !== undefined)
            url_ += "taskCandidateGroup=" + encodeURIComponent("" + taskCandidateGroup) + "&"; 
        if (taskCandidateGroupIn !== undefined)
            url_ += "taskCandidateGroupIn=" + encodeURIComponent("" + taskCandidateGroupIn) + "&"; 
        if (taskCandidateUser !== undefined)
            url_ += "taskCandidateUser=" + encodeURIComponent("" + taskCandidateUser) + "&"; 
        if (taskCategory !== undefined)
            url_ += "taskCategory=" + encodeURIComponent("" + taskCategory) + "&"; 
        if (taskCompletedAfter !== undefined)
            url_ += "taskCompletedAfter=" + encodeURIComponent("" + taskCompletedAfter) + "&"; 
        if (taskCompletedBefore !== undefined)
            url_ += "taskCompletedBefore=" + encodeURIComponent("" + taskCompletedBefore) + "&"; 
        if (taskCreatedAfter !== undefined)
            url_ += "taskCreatedAfter=" + encodeURIComponent("" + taskCreatedAfter) + "&"; 
        if (taskCreatedBefore !== undefined)
            url_ += "taskCreatedBefore=" + encodeURIComponent("" + taskCreatedBefore) + "&"; 
        if (taskDefinitionKey !== undefined)
            url_ += "taskDefinitionKey=" + encodeURIComponent("" + taskDefinitionKey) + "&"; 
        if (taskDescription !== undefined)
            url_ += "taskDescription=" + encodeURIComponent("" + taskDescription) + "&"; 
        if (taskDueAfter !== undefined)
            url_ += "taskDueAfter=" + encodeURIComponent("" + taskDueAfter) + "&"; 
        if (taskDueBefore !== undefined)
            url_ += "taskDueBefore=" + encodeURIComponent("" + taskDueBefore) + "&"; 
        if (taskId !== undefined)
            url_ += "taskId=" + encodeURIComponent("" + taskId) + "&"; 
        if (taskInvolvedUser !== undefined)
            url_ += "taskInvolvedUser=" + encodeURIComponent("" + taskInvolvedUser) + "&"; 
        if (taskName !== undefined)
            url_ += "taskName=" + encodeURIComponent("" + taskName) + "&"; 
        if (taskOwner !== undefined)
            url_ += "taskOwner=" + encodeURIComponent("" + taskOwner) + "&"; 
        if (taskParentTaskId !== undefined)
            url_ += "taskParentTaskId=" + encodeURIComponent("" + taskParentTaskId) + "&"; 
        if (taskPriority !== undefined)
            url_ += "taskPriority=" + encodeURIComponent("" + taskPriority) + "&"; 
        if (tenantId !== undefined)
            url_ += "tenantId=" + encodeURIComponent("" + tenantId) + "&"; 
        if (unfinished !== undefined)
            url_ += "unfinished=" + encodeURIComponent("" + unfinished) + "&"; 
        if (userId !== undefined)
            url_ += "userId=" + encodeURIComponent("" + userId) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processListTodo(_response);
        });
    }

    protected processListTodo(response: AxiosResponse): Promise<FlowablePage> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 ? FlowablePage.fromJS(resultData200) : new FlowablePage();
            return result200;
        }
        return Promise.resolve<FlowablePage>(<any>null);
    }

    /**
     * 获取任务详情
     * @param taskId (optional) 任务ID
     * @return OK
     */
    queryById(taskId: string | null | undefined): Promise<TaskResponse> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.251:31080/blade-flow')+ "/flowable/task/queryById?";
        if (taskId !== undefined)
            url_ += "taskId=" + encodeURIComponent("" + taskId) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processQueryById(_response);
        });
    }

    protected processQueryById(response: AxiosResponse): Promise<TaskResponse> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 ? TaskResponse.fromJS(resultData200) : new TaskResponse();
            return result200;
        }
        return Promise.resolve<TaskResponse>(<any>null);
    }

    /**
     * 阅读任务
     * @param taskRequest taskRequest
     * @return OK
     */
    read(taskRequest: TaskRequest): Promise<void> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.251:31080/blade-flow')+ "/flowable/task/read";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(taskRequest);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json", 
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processRead(_response);
        });
    }

    protected processRead(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            return Promise.resolve<void>(<any>null);
        }
        return Promise.resolve<void>(<any>null);
    }

    /**
     * 获取任务表单
     * @param taskId taskId
     * @return OK
     */
    renderedTaskForm(taskId: string): Promise<any> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.251:31080/blade-flow')+ "/flowable/task/renderedTaskForm?";
        if (taskId === undefined || taskId === null)
            throw new Error("The parameter 'taskId' must be defined and cannot be null.");
        else
            url_ += "taskId=" + encodeURIComponent("" + taskId) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processRenderedTaskForm(_response);
        });
    }

    protected processRenderedTaskForm(response: AxiosResponse): Promise<any> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return result200;
        }
        return Promise.resolve<any>(<any>null);
    }

    /**
     * 结束流程实例
     * @param taskRequest taskRequest
     * @return OK
     */
    stopProcessInstance(taskRequest: TaskRequest): Promise<void> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.251:31080/blade-flow')+ "/flowable/task/stopProcessInstance";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(taskRequest);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json", 
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processStopProcessInstance(_response);
        });
    }

    protected processStopProcessInstance(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            return Promise.resolve<void>(<any>null);
        }
        return Promise.resolve<void>(<any>null);
    }

    /**
     * 取消认领任务
     * @param taskRequest taskRequest
     * @return OK
     */
    unclaim(taskRequest: TaskRequest): Promise<void> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.251:31080/blade-flow')+ "/flowable/task/unclaim";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(taskRequest);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json", 
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processUnclaim(_response);
        });
    }

    protected processUnclaim(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            return Promise.resolve<void>(<any>null);
        }
        return Promise.resolve<void>(<any>null);
    }

    /**
     * 修改任务
     * @param taskUpdateRequest taskUpdateRequest
     * @return OK
     */
    update(taskUpdateRequest: TaskUpdateRequest): Promise<TaskResponse> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.251:31080/blade-flow')+ "/flowable/task/update";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(taskUpdateRequest);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json", 
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processUpdate(_response);
        });
    }

    protected processUpdate(response: AxiosResponse): Promise<TaskResponse> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 ? TaskResponse.fromJS(resultData200) : new TaskResponse();
            return result200;
        }
        return Promise.resolve<TaskResponse>(<any>null);
    }
}

export class CategoryVo implements ICategoryVo {
    category!: string | undefined;
    categoryName!: string | undefined;
    processDefinitionVoList!: ProcessDefinitionVo[] | undefined;

    constructor(data?: ICategoryVo) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.category = data["category"];
            this.categoryName = data["categoryName"];
            if (data["processDefinitionVoList"] && data["processDefinitionVoList"].constructor === Array) {
                this.processDefinitionVoList = [] as any;
                for (let item of data["processDefinitionVoList"])
                    this.processDefinitionVoList!.push(ProcessDefinitionVo.fromJS(item));
            }
        }
    }

    static fromJS(data: any): CategoryVo {
        data = typeof data === 'object' ? data : {};
        let result = new CategoryVo();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["category"] = this.category;
        data["categoryName"] = this.categoryName;
        if (this.processDefinitionVoList && this.processDefinitionVoList.constructor === Array) {
            data["processDefinitionVoList"] = [];
            for (let item of this.processDefinitionVoList)
                data["processDefinitionVoList"].push(item.toJSON());
        }
        return data; 
    }
}

export interface ICategoryVo {
    category: string | undefined;
    categoryName: string | undefined;
    processDefinitionVoList: ProcessDefinitionVo[] | undefined;
}

export class CcToVo implements ICcToVo {
    userId!: string | undefined;
    userName!: string | undefined;

    constructor(data?: ICcToVo) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.userId = data["userId"];
            this.userName = data["userName"];
        }
    }

    static fromJS(data: any): CcToVo {
        data = typeof data === 'object' ? data : {};
        let result = new CcToVo();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userId"] = this.userId;
        data["userName"] = this.userName;
        return data; 
    }
}

export interface ICcToVo {
    userId: string | undefined;
    userName: string | undefined;
}

export class CommentResponse implements ICommentResponse {
    fullMessage!: string | undefined;
    id!: string | undefined;
    message!: string | undefined;
    processInstanceId!: string | undefined;
    taskDefinitionKey!: string | undefined;
    taskDefinitionName!: string | undefined;
    taskId!: string | undefined;
    taskName!: string | undefined;
    time!: Date | undefined;
    type!: string | undefined;
    typeDesc!: string | undefined;
    userId!: string | undefined;
    userName!: string | undefined;

    constructor(data?: ICommentResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.fullMessage = data["fullMessage"];
            this.id = data["id"];
            this.message = data["message"];
            this.processInstanceId = data["processInstanceId"];
            this.taskDefinitionKey = data["taskDefinitionKey"];
            this.taskDefinitionName = data["taskDefinitionName"];
            this.taskId = data["taskId"];
            this.taskName = data["taskName"];
            this.time = data["time"] ? new Date(data["time"].toString()) : <any>undefined;
            this.type = data["type"];
            this.typeDesc = data["typeDesc"];
            this.userId = data["userId"];
            this.userName = data["userName"];
        }
    }

    static fromJS(data: any): CommentResponse {
        data = typeof data === 'object' ? data : {};
        let result = new CommentResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["fullMessage"] = this.fullMessage;
        data["id"] = this.id;
        data["message"] = this.message;
        data["processInstanceId"] = this.processInstanceId;
        data["taskDefinitionKey"] = this.taskDefinitionKey;
        data["taskDefinitionName"] = this.taskDefinitionName;
        data["taskId"] = this.taskId;
        data["taskName"] = this.taskName;
        data["time"] = this.time ? this.time.toISOString() : <any>undefined;
        data["type"] = this.type;
        data["typeDesc"] = this.typeDesc;
        data["userId"] = this.userId;
        data["userName"] = this.userName;
        return data; 
    }
}

export interface ICommentResponse {
    fullMessage: string | undefined;
    id: string | undefined;
    message: string | undefined;
    processInstanceId: string | undefined;
    taskDefinitionKey: string | undefined;
    taskDefinitionName: string | undefined;
    taskId: string | undefined;
    taskName: string | undefined;
    time: Date | undefined;
    type: string | undefined;
    typeDesc: string | undefined;
    userId: string | undefined;
    userName: string | undefined;
}

export class ExecuteTaskDataVo implements IExecuteTaskDataVo {
    buttons!: string[] | undefined;
    initiator!: boolean | undefined;
    renderedStartForm!: any | undefined;
    renderedTaskForm!: any | undefined;
    showBusinessKey!: boolean | undefined;
    startFormKey!: string | undefined;
    startUserId!: string | undefined;
    taskFormKey!: string | undefined;
    variables!: any | undefined;

    constructor(data?: IExecuteTaskDataVo) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            if (data["buttons"] && data["buttons"].constructor === Array) {
                this.buttons = [] as any;
                for (let item of data["buttons"])
                    this.buttons!.push(item);
            }
            this.initiator = data["initiator"];
            this.renderedStartForm = data["renderedStartForm"];
            this.renderedTaskForm = data["renderedTaskForm"];
            this.showBusinessKey = data["showBusinessKey"];
            this.startFormKey = data["startFormKey"];
            this.startUserId = data["startUserId"];
            this.taskFormKey = data["taskFormKey"];
            this.variables = data["variables"];
        }
    }

    static fromJS(data: any): ExecuteTaskDataVo {
        data = typeof data === 'object' ? data : {};
        let result = new ExecuteTaskDataVo();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.buttons && this.buttons.constructor === Array) {
            data["buttons"] = [];
            for (let item of this.buttons)
                data["buttons"].push(item);
        }
        data["initiator"] = this.initiator;
        data["renderedStartForm"] = this.renderedStartForm;
        data["renderedTaskForm"] = this.renderedTaskForm;
        data["showBusinessKey"] = this.showBusinessKey;
        data["startFormKey"] = this.startFormKey;
        data["startUserId"] = this.startUserId;
        data["taskFormKey"] = this.taskFormKey;
        data["variables"] = this.variables;
        return data; 
    }
}

export interface IExecuteTaskDataVo {
    buttons: string[] | undefined;
    initiator: boolean | undefined;
    renderedStartForm: any | undefined;
    renderedTaskForm: any | undefined;
    showBusinessKey: boolean | undefined;
    startFormKey: string | undefined;
    startUserId: string | undefined;
    taskFormKey: string | undefined;
    variables: any | undefined;
}

export class FlowNodeResponse implements IFlowNodeResponse {
    endTime!: Date | undefined;
    nodeId!: string | undefined;
    nodeName!: string | undefined;
    userId!: string | undefined;
    userName!: string | undefined;

    constructor(data?: IFlowNodeResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.endTime = data["endTime"] ? new Date(data["endTime"].toString()) : <any>undefined;
            this.nodeId = data["nodeId"];
            this.nodeName = data["nodeName"];
            this.userId = data["userId"];
            this.userName = data["userName"];
        }
    }

    static fromJS(data: any): FlowNodeResponse {
        data = typeof data === 'object' ? data : {};
        let result = new FlowNodeResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["endTime"] = this.endTime ? this.endTime.toISOString() : <any>undefined;
        data["nodeId"] = this.nodeId;
        data["nodeName"] = this.nodeName;
        data["userId"] = this.userId;
        data["userName"] = this.userName;
        return data; 
    }
}

export interface IFlowNodeResponse {
    endTime: Date | undefined;
    nodeId: string | undefined;
    nodeName: string | undefined;
    userId: string | undefined;
    userName: string | undefined;
}

export class FlowableForm implements IFlowableForm {
    createBy!: string | undefined;
    createDate!: Date | undefined;
    createTime!: Date | undefined;
    /** 表单Json */
    formJson!: string | undefined;
    /** 表单Key */
    formKey!: string | undefined;
    /** 表单名称 */
    formName!: string | undefined;
    updateBy!: string | undefined;
    updateDate!: Date | undefined;
    updateTime!: Date | undefined;

    constructor(data?: IFlowableForm) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.createBy = data["createBy"];
            this.createDate = data["createDate"] ? new Date(data["createDate"].toString()) : <any>undefined;
            this.createTime = data["createTime"] ? new Date(data["createTime"].toString()) : <any>undefined;
            this.formJson = data["formJson"];
            this.formKey = data["formKey"];
            this.formName = data["formName"];
            this.updateBy = data["updateBy"];
            this.updateDate = data["updateDate"] ? new Date(data["updateDate"].toString()) : <any>undefined;
            this.updateTime = data["updateTime"] ? new Date(data["updateTime"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): FlowableForm {
        data = typeof data === 'object' ? data : {};
        let result = new FlowableForm();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["createBy"] = this.createBy;
        data["createDate"] = this.createDate ? this.createDate.toISOString() : <any>undefined;
        data["createTime"] = this.createTime ? this.createTime.toISOString() : <any>undefined;
        data["formJson"] = this.formJson;
        data["formKey"] = this.formKey;
        data["formName"] = this.formName;
        data["updateBy"] = this.updateBy;
        data["updateDate"] = this.updateDate ? this.updateDate.toISOString() : <any>undefined;
        data["updateTime"] = this.updateTime ? this.updateTime.toISOString() : <any>undefined;
        return data; 
    }
}

export interface IFlowableForm {
    createBy: string | undefined;
    createDate: Date | undefined;
    createTime: Date | undefined;
    /** 表单Json */
    formJson: string | undefined;
    /** 表单Key */
    formKey: string | undefined;
    /** 表单名称 */
    formName: string | undefined;
    updateBy: string | undefined;
    updateDate: Date | undefined;
    updateTime: Date | undefined;
}

export class FlowablePage implements IFlowablePage {
    current!: number | undefined;
    offset!: string | undefined;
    orders!: Order[] | undefined;
    records!: any[] | undefined;
    size!: number | undefined;
    total!: string | undefined;

    constructor(data?: IFlowablePage) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.current = data["current"];
            this.offset = data["offset"];
            if (data["orders"] && data["orders"].constructor === Array) {
                this.orders = [] as any;
                for (let item of data["orders"])
                    this.orders!.push(Order.fromJS(item));
            }
            if (data["records"] && data["records"].constructor === Array) {
                this.records = [] as any;
                for (let item of data["records"])
                    this.records!.push(item);
            }
            this.size = data["size"];
            this.total = data["total"];
        }
    }

    static fromJS(data: any): FlowablePage {
        data = typeof data === 'object' ? data : {};
        let result = new FlowablePage();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["current"] = this.current;
        data["offset"] = this.offset;
        if (this.orders && this.orders.constructor === Array) {
            data["orders"] = [];
            for (let item of this.orders)
                data["orders"].push(item.toJSON());
        }
        if (this.records && this.records.constructor === Array) {
            data["records"] = [];
            for (let item of this.records)
                data["records"].push(item);
        }
        data["size"] = this.size;
        data["total"] = this.total;
        return data; 
    }
}

export interface IFlowablePage {
    current: number | undefined;
    offset: string | undefined;
    orders: Order[] | undefined;
    records: any[] | undefined;
    size: number | undefined;
    total: string | undefined;
}

export class IPageOfFlowableForm implements IIPageOfFlowableForm {
    current!: string | undefined;
    hitCount!: boolean | undefined;
    pages!: string | undefined;
    records!: FlowableForm[] | undefined;
    searchCount!: boolean | undefined;
    size!: string | undefined;
    total!: string | undefined;

    constructor(data?: IIPageOfFlowableForm) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.current = data["current"];
            this.hitCount = data["hitCount"];
            this.pages = data["pages"];
            if (data["records"] && data["records"].constructor === Array) {
                this.records = [] as any;
                for (let item of data["records"])
                    this.records!.push(FlowableForm.fromJS(item));
            }
            this.searchCount = data["searchCount"];
            this.size = data["size"];
            this.total = data["total"];
        }
    }

    static fromJS(data: any): IPageOfFlowableForm {
        data = typeof data === 'object' ? data : {};
        let result = new IPageOfFlowableForm();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["current"] = this.current;
        data["hitCount"] = this.hitCount;
        data["pages"] = this.pages;
        if (this.records && this.records.constructor === Array) {
            data["records"] = [];
            for (let item of this.records)
                data["records"].push(item.toJSON());
        }
        data["searchCount"] = this.searchCount;
        data["size"] = this.size;
        data["total"] = this.total;
        return data; 
    }
}

export interface IIPageOfFlowableForm {
    current: string | undefined;
    hitCount: boolean | undefined;
    pages: string | undefined;
    records: FlowableForm[] | undefined;
    searchCount: boolean | undefined;
    size: string | undefined;
    total: string | undefined;
}

export class IdentityRequest implements IIdentityRequest {
    /** 流程授权的对象ID (用户ID/岗位ID) */
    identityId!: string | undefined;
    /** 授权类型 用户/岗位 1:用户 2：岗位 字典维护 */
    identityType!: string | undefined;
    /** 流程定义ID */
    processDefinitionId!: string | undefined;
    /** 任务ID: 任务管理筛选使用 */
    taskId!: string | undefined;

    constructor(data?: IIdentityRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.identityId = data["identityId"];
            this.identityType = data["identityType"];
            this.processDefinitionId = data["processDefinitionId"];
            this.taskId = data["taskId"];
        }
    }

    static fromJS(data: any): IdentityRequest {
        data = typeof data === 'object' ? data : {};
        let result = new IdentityRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["identityId"] = this.identityId;
        data["identityType"] = this.identityType;
        data["processDefinitionId"] = this.processDefinitionId;
        data["taskId"] = this.taskId;
        return data; 
    }
}

export interface IIdentityRequest {
    /** 流程授权的对象ID (用户ID/岗位ID) */
    identityId: string | undefined;
    /** 授权类型 用户/岗位 1:用户 2：岗位 字典维护 */
    identityType: string | undefined;
    /** 流程定义ID */
    processDefinitionId: string | undefined;
    /** 任务ID: 任务管理筛选使用 */
    taskId: string | undefined;
}

export class IdentityResponse implements IIdentityResponse {
    identityId!: string | undefined;
    identityName!: string | undefined;
    identityType!: string | undefined;

    constructor(data?: IIdentityResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.identityId = data["identityId"];
            this.identityName = data["identityName"];
            this.identityType = data["identityType"];
        }
    }

    static fromJS(data: any): IdentityResponse {
        data = typeof data === 'object' ? data : {};
        let result = new IdentityResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["identityId"] = this.identityId;
        data["identityName"] = this.identityName;
        data["identityType"] = this.identityType;
        return data; 
    }
}

export interface IIdentityResponse {
    identityId: string | undefined;
    identityName: string | undefined;
    identityType: string | undefined;
}

export class Job implements IJob {
    category!: string | undefined;
    correlationId!: string | undefined;
    createTime!: Date | undefined;
    customValues!: string | undefined;
    duedate!: Date | undefined;
    elementId!: string | undefined;
    elementName!: string | undefined;
    exceptionMessage!: string | undefined;
    exclusive!: boolean | undefined;
    executionId!: string | undefined;
    id!: string | undefined;
    jobHandlerConfiguration!: string | undefined;
    jobHandlerType!: string | undefined;
    jobType!: string | undefined;
    processDefinitionId!: string | undefined;
    processInstanceId!: string | undefined;
    retries!: number | undefined;
    scopeDefinitionId!: string | undefined;
    scopeId!: string | undefined;
    scopeType!: string | undefined;
    subScopeId!: string | undefined;
    tenantId!: string | undefined;

    constructor(data?: IJob) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.category = data["category"];
            this.correlationId = data["correlationId"];
            this.createTime = data["createTime"] ? new Date(data["createTime"].toString()) : <any>undefined;
            this.customValues = data["customValues"];
            this.duedate = data["duedate"] ? new Date(data["duedate"].toString()) : <any>undefined;
            this.elementId = data["elementId"];
            this.elementName = data["elementName"];
            this.exceptionMessage = data["exceptionMessage"];
            this.exclusive = data["exclusive"];
            this.executionId = data["executionId"];
            this.id = data["id"];
            this.jobHandlerConfiguration = data["jobHandlerConfiguration"];
            this.jobHandlerType = data["jobHandlerType"];
            this.jobType = data["jobType"];
            this.processDefinitionId = data["processDefinitionId"];
            this.processInstanceId = data["processInstanceId"];
            this.retries = data["retries"];
            this.scopeDefinitionId = data["scopeDefinitionId"];
            this.scopeId = data["scopeId"];
            this.scopeType = data["scopeType"];
            this.subScopeId = data["subScopeId"];
            this.tenantId = data["tenantId"];
        }
    }

    static fromJS(data: any): Job {
        data = typeof data === 'object' ? data : {};
        let result = new Job();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["category"] = this.category;
        data["correlationId"] = this.correlationId;
        data["createTime"] = this.createTime ? this.createTime.toISOString() : <any>undefined;
        data["customValues"] = this.customValues;
        data["duedate"] = this.duedate ? this.duedate.toISOString() : <any>undefined;
        data["elementId"] = this.elementId;
        data["elementName"] = this.elementName;
        data["exceptionMessage"] = this.exceptionMessage;
        data["exclusive"] = this.exclusive;
        data["executionId"] = this.executionId;
        data["id"] = this.id;
        data["jobHandlerConfiguration"] = this.jobHandlerConfiguration;
        data["jobHandlerType"] = this.jobHandlerType;
        data["jobType"] = this.jobType;
        data["processDefinitionId"] = this.processDefinitionId;
        data["processInstanceId"] = this.processInstanceId;
        data["retries"] = this.retries;
        data["scopeDefinitionId"] = this.scopeDefinitionId;
        data["scopeId"] = this.scopeId;
        data["scopeType"] = this.scopeType;
        data["subScopeId"] = this.subScopeId;
        data["tenantId"] = this.tenantId;
        return data; 
    }
}

export interface IJob {
    category: string | undefined;
    correlationId: string | undefined;
    createTime: Date | undefined;
    customValues: string | undefined;
    duedate: Date | undefined;
    elementId: string | undefined;
    elementName: string | undefined;
    exceptionMessage: string | undefined;
    exclusive: boolean | undefined;
    executionId: string | undefined;
    id: string | undefined;
    jobHandlerConfiguration: string | undefined;
    jobHandlerType: string | undefined;
    jobType: string | undefined;
    processDefinitionId: string | undefined;
    processInstanceId: string | undefined;
    retries: number | undefined;
    scopeDefinitionId: string | undefined;
    scopeId: string | undefined;
    scopeType: string | undefined;
    subScopeId: string | undefined;
    tenantId: string | undefined;
}

export class Locale implements ILocale {
    country!: string | undefined;
    displayCountry!: string | undefined;
    displayLanguage!: string | undefined;
    displayName!: string | undefined;
    displayScript!: string | undefined;
    displayVariant!: string | undefined;
    extensionKeys!: any[] | undefined;
    iso3Country!: string | undefined;
    iso3Language!: string | undefined;
    language!: string | undefined;
    script!: string | undefined;
    unicodeLocaleAttributes!: string[] | undefined;
    unicodeLocaleKeys!: string[] | undefined;
    variant!: string | undefined;

    constructor(data?: ILocale) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.country = data["country"];
            this.displayCountry = data["displayCountry"];
            this.displayLanguage = data["displayLanguage"];
            this.displayName = data["displayName"];
            this.displayScript = data["displayScript"];
            this.displayVariant = data["displayVariant"];
            if (data["extensionKeys"] && data["extensionKeys"].constructor === Array) {
                this.extensionKeys = [] as any;
                for (let item of data["extensionKeys"])
                    this.extensionKeys!.push(item);
            }
            this.iso3Country = data["iso3Country"];
            this.iso3Language = data["iso3Language"];
            this.language = data["language"];
            this.script = data["script"];
            if (data["unicodeLocaleAttributes"] && data["unicodeLocaleAttributes"].constructor === Array) {
                this.unicodeLocaleAttributes = [] as any;
                for (let item of data["unicodeLocaleAttributes"])
                    this.unicodeLocaleAttributes!.push(item);
            }
            if (data["unicodeLocaleKeys"] && data["unicodeLocaleKeys"].constructor === Array) {
                this.unicodeLocaleKeys = [] as any;
                for (let item of data["unicodeLocaleKeys"])
                    this.unicodeLocaleKeys!.push(item);
            }
            this.variant = data["variant"];
        }
    }

    static fromJS(data: any): Locale {
        data = typeof data === 'object' ? data : {};
        let result = new Locale();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["country"] = this.country;
        data["displayCountry"] = this.displayCountry;
        data["displayLanguage"] = this.displayLanguage;
        data["displayName"] = this.displayName;
        data["displayScript"] = this.displayScript;
        data["displayVariant"] = this.displayVariant;
        if (this.extensionKeys && this.extensionKeys.constructor === Array) {
            data["extensionKeys"] = [];
            for (let item of this.extensionKeys)
                data["extensionKeys"].push(item);
        }
        data["iso3Country"] = this.iso3Country;
        data["iso3Language"] = this.iso3Language;
        data["language"] = this.language;
        data["script"] = this.script;
        if (this.unicodeLocaleAttributes && this.unicodeLocaleAttributes.constructor === Array) {
            data["unicodeLocaleAttributes"] = [];
            for (let item of this.unicodeLocaleAttributes)
                data["unicodeLocaleAttributes"].push(item);
        }
        if (this.unicodeLocaleKeys && this.unicodeLocaleKeys.constructor === Array) {
            data["unicodeLocaleKeys"] = [];
            for (let item of this.unicodeLocaleKeys)
                data["unicodeLocaleKeys"].push(item);
        }
        data["variant"] = this.variant;
        return data; 
    }
}

export interface ILocale {
    country: string | undefined;
    displayCountry: string | undefined;
    displayLanguage: string | undefined;
    displayName: string | undefined;
    displayScript: string | undefined;
    displayVariant: string | undefined;
    extensionKeys: any[] | undefined;
    iso3Country: string | undefined;
    iso3Language: string | undefined;
    language: string | undefined;
    script: string | undefined;
    unicodeLocaleAttributes: string[] | undefined;
    unicodeLocaleKeys: string[] | undefined;
    variant: string | undefined;
}

export class ModelRequest implements IModelRequest {
    /** 级联(删除包含历史时候使用) */
    cascade!: boolean | undefined;
    /** 模型类别 */
    category!: string | undefined;
    /** 模型描述 */
    description!: string | undefined;
    /** 流程设计 */
    editor!: string | undefined;
    /** 模型ID */
    id!: string | undefined;
    /** 流程模型Key */
    key!: string | undefined;
    /** 模型名称 */
    name!: string | undefined;
    /** 是否是最新版本 */
    newVersion!: boolean | undefined;
    /** 所属租户 */
    tenantId!: string | undefined;

    constructor(data?: IModelRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.cascade = data["cascade"];
            this.category = data["category"];
            this.description = data["description"];
            this.editor = data["editor"];
            this.id = data["id"];
            this.key = data["key"];
            this.name = data["name"];
            this.newVersion = data["newVersion"];
            this.tenantId = data["tenantId"];
        }
    }

    static fromJS(data: any): ModelRequest {
        data = typeof data === 'object' ? data : {};
        let result = new ModelRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["cascade"] = this.cascade;
        data["category"] = this.category;
        data["description"] = this.description;
        data["editor"] = this.editor;
        data["id"] = this.id;
        data["key"] = this.key;
        data["name"] = this.name;
        data["newVersion"] = this.newVersion;
        data["tenantId"] = this.tenantId;
        return data; 
    }
}

export interface IModelRequest {
    /** 级联(删除包含历史时候使用) */
    cascade: boolean | undefined;
    /** 模型类别 */
    category: string | undefined;
    /** 模型描述 */
    description: string | undefined;
    /** 流程设计 */
    editor: string | undefined;
    /** 模型ID */
    id: string | undefined;
    /** 流程模型Key */
    key: string | undefined;
    /** 模型名称 */
    name: string | undefined;
    /** 是否是最新版本 */
    newVersion: boolean | undefined;
    /** 所属租户 */
    tenantId: string | undefined;
}

export class ModelResponse implements IModelResponse {
    category!: string | undefined;
    createTime!: Date | undefined;
    deployed!: boolean | undefined;
    description!: string | undefined;
    editor!: string | undefined;
    id!: string | undefined;
    key!: string | undefined;
    lastUpdateTime!: Date | undefined;
    name!: string | undefined;
    tenantId!: string | undefined;
    version!: number | undefined;

    constructor(data?: IModelResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.category = data["category"];
            this.createTime = data["createTime"] ? new Date(data["createTime"].toString()) : <any>undefined;
            this.deployed = data["deployed"];
            this.description = data["description"];
            this.editor = data["editor"];
            this.id = data["id"];
            this.key = data["key"];
            this.lastUpdateTime = data["lastUpdateTime"] ? new Date(data["lastUpdateTime"].toString()) : <any>undefined;
            this.name = data["name"];
            this.tenantId = data["tenantId"];
            this.version = data["version"];
        }
    }

    static fromJS(data: any): ModelResponse {
        data = typeof data === 'object' ? data : {};
        let result = new ModelResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["category"] = this.category;
        data["createTime"] = this.createTime ? this.createTime.toISOString() : <any>undefined;
        data["deployed"] = this.deployed;
        data["description"] = this.description;
        data["editor"] = this.editor;
        data["id"] = this.id;
        data["key"] = this.key;
        data["lastUpdateTime"] = this.lastUpdateTime ? this.lastUpdateTime.toISOString() : <any>undefined;
        data["name"] = this.name;
        data["tenantId"] = this.tenantId;
        data["version"] = this.version;
        return data; 
    }
}

export interface IModelResponse {
    category: string | undefined;
    createTime: Date | undefined;
    deployed: boolean | undefined;
    description: string | undefined;
    editor: string | undefined;
    id: string | undefined;
    key: string | undefined;
    lastUpdateTime: Date | undefined;
    name: string | undefined;
    tenantId: string | undefined;
    version: number | undefined;
}

export class Order implements IOrder {
    direction!: OrderDirection | undefined;
    property!: string | undefined;

    constructor(data?: IOrder) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.direction = data["direction"];
            this.property = data["property"];
        }
    }

    static fromJS(data: any): Order {
        data = typeof data === 'object' ? data : {};
        let result = new Order();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["direction"] = this.direction;
        data["property"] = this.property;
        return data; 
    }
}

export interface IOrder {
    direction: OrderDirection | undefined;
    property: string | undefined;
}

export class ProcessDefinitionRequest implements IProcessDefinitionRequest {
    /** 日期 */
    date!: Date | undefined;
    /** 包含流程实例 */
    includeProcessInstances!: boolean | undefined;
    /** 流程定义ID */
    processDefinitionId!: string | undefined;

    constructor(data?: IProcessDefinitionRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.date = data["date"] ? new Date(data["date"].toString()) : <any>undefined;
            this.includeProcessInstances = data["includeProcessInstances"];
            this.processDefinitionId = data["processDefinitionId"];
        }
    }

    static fromJS(data: any): ProcessDefinitionRequest {
        data = typeof data === 'object' ? data : {};
        let result = new ProcessDefinitionRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["date"] = this.date ? this.date.toISOString() : <any>undefined;
        data["includeProcessInstances"] = this.includeProcessInstances;
        data["processDefinitionId"] = this.processDefinitionId;
        return data; 
    }
}

export interface IProcessDefinitionRequest {
    /** 日期 */
    date: Date | undefined;
    /** 包含流程实例 */
    includeProcessInstances: boolean | undefined;
    /** 流程定义ID */
    processDefinitionId: string | undefined;
}

export class ProcessDefinitionResponse implements IProcessDefinitionResponse {
    category!: string | undefined;
    description!: string | undefined;
    formKey!: string | undefined;
    graphicalNotationDefined!: boolean | undefined;
    id!: string | undefined;
    key!: string | undefined;
    name!: string | undefined;
    suspended!: boolean | undefined;
    tenantId!: string | undefined;
    version!: number | undefined;

    constructor(data?: IProcessDefinitionResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.category = data["category"];
            this.description = data["description"];
            this.formKey = data["formKey"];
            this.graphicalNotationDefined = data["graphicalNotationDefined"];
            this.id = data["id"];
            this.key = data["key"];
            this.name = data["name"];
            this.suspended = data["suspended"];
            this.tenantId = data["tenantId"];
            this.version = data["version"];
        }
    }

    static fromJS(data: any): ProcessDefinitionResponse {
        data = typeof data === 'object' ? data : {};
        let result = new ProcessDefinitionResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["category"] = this.category;
        data["description"] = this.description;
        data["formKey"] = this.formKey;
        data["graphicalNotationDefined"] = this.graphicalNotationDefined;
        data["id"] = this.id;
        data["key"] = this.key;
        data["name"] = this.name;
        data["suspended"] = this.suspended;
        data["tenantId"] = this.tenantId;
        data["version"] = this.version;
        return data; 
    }
}

export interface IProcessDefinitionResponse {
    category: string | undefined;
    description: string | undefined;
    formKey: string | undefined;
    graphicalNotationDefined: boolean | undefined;
    id: string | undefined;
    key: string | undefined;
    name: string | undefined;
    suspended: boolean | undefined;
    tenantId: string | undefined;
    version: number | undefined;
}

export class ProcessDefinitionVo implements IProcessDefinitionVo {
    category!: string | undefined;
    categoryName!: string | undefined;
    count!: string | undefined;
    processDefinitionKey!: string | undefined;
    processDefinitionName!: string | undefined;

    constructor(data?: IProcessDefinitionVo) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.category = data["category"];
            this.categoryName = data["categoryName"];
            this.count = data["count"];
            this.processDefinitionKey = data["processDefinitionKey"];
            this.processDefinitionName = data["processDefinitionName"];
        }
    }

    static fromJS(data: any): ProcessDefinitionVo {
        data = typeof data === 'object' ? data : {};
        let result = new ProcessDefinitionVo();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["category"] = this.category;
        data["categoryName"] = this.categoryName;
        data["count"] = this.count;
        data["processDefinitionKey"] = this.processDefinitionKey;
        data["processDefinitionName"] = this.processDefinitionName;
        return data; 
    }
}

export interface IProcessDefinitionVo {
    category: string | undefined;
    categoryName: string | undefined;
    count: string | undefined;
    processDefinitionKey: string | undefined;
    processDefinitionName: string | undefined;
}

export class ProcessInstanceDetailResponse implements IProcessInstanceDetailResponse {
    businessKey!: string | undefined;
    deleteReason!: string | undefined;
    durationInMillis!: string | undefined;
    endTime!: Date | undefined;
    id!: string | undefined;
    name!: string | undefined;
    processDefinitionId!: string | undefined;
    processDefinitionKey!: string | undefined;
    processDefinitionName!: string | undefined;
    processDefinitionVersion!: number | undefined;
    startActivityId!: string | undefined;
    startTime!: Date | undefined;
    startUserId!: string | undefined;
    startUserName!: string | undefined;
    superProcessInstanceId!: string | undefined;
    suspended!: boolean | undefined;
    tenantId!: string | undefined;

    constructor(data?: IProcessInstanceDetailResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.businessKey = data["businessKey"];
            this.deleteReason = data["deleteReason"];
            this.durationInMillis = data["durationInMillis"];
            this.endTime = data["endTime"] ? new Date(data["endTime"].toString()) : <any>undefined;
            this.id = data["id"];
            this.name = data["name"];
            this.processDefinitionId = data["processDefinitionId"];
            this.processDefinitionKey = data["processDefinitionKey"];
            this.processDefinitionName = data["processDefinitionName"];
            this.processDefinitionVersion = data["processDefinitionVersion"];
            this.startActivityId = data["startActivityId"];
            this.startTime = data["startTime"] ? new Date(data["startTime"].toString()) : <any>undefined;
            this.startUserId = data["startUserId"];
            this.startUserName = data["startUserName"];
            this.superProcessInstanceId = data["superProcessInstanceId"];
            this.suspended = data["suspended"];
            this.tenantId = data["tenantId"];
        }
    }

    static fromJS(data: any): ProcessInstanceDetailResponse {
        data = typeof data === 'object' ? data : {};
        let result = new ProcessInstanceDetailResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["businessKey"] = this.businessKey;
        data["deleteReason"] = this.deleteReason;
        data["durationInMillis"] = this.durationInMillis;
        data["endTime"] = this.endTime ? this.endTime.toISOString() : <any>undefined;
        data["id"] = this.id;
        data["name"] = this.name;
        data["processDefinitionId"] = this.processDefinitionId;
        data["processDefinitionKey"] = this.processDefinitionKey;
        data["processDefinitionName"] = this.processDefinitionName;
        data["processDefinitionVersion"] = this.processDefinitionVersion;
        data["startActivityId"] = this.startActivityId;
        data["startTime"] = this.startTime ? this.startTime.toISOString() : <any>undefined;
        data["startUserId"] = this.startUserId;
        data["startUserName"] = this.startUserName;
        data["superProcessInstanceId"] = this.superProcessInstanceId;
        data["suspended"] = this.suspended;
        data["tenantId"] = this.tenantId;
        return data; 
    }
}

export interface IProcessInstanceDetailResponse {
    businessKey: string | undefined;
    deleteReason: string | undefined;
    durationInMillis: string | undefined;
    endTime: Date | undefined;
    id: string | undefined;
    name: string | undefined;
    processDefinitionId: string | undefined;
    processDefinitionKey: string | undefined;
    processDefinitionName: string | undefined;
    processDefinitionVersion: number | undefined;
    startActivityId: string | undefined;
    startTime: Date | undefined;
    startUserId: string | undefined;
    startUserName: string | undefined;
    superProcessInstanceId: string | undefined;
    suspended: boolean | undefined;
    tenantId: string | undefined;
}

export class ProcessInstanceRequest implements IProcessInstanceRequest {
    /** 业务Key */
    businessKey!: string | undefined;
    /** 抄送人 */
    ccToVos!: CcToVo[] | undefined;
    /** 发起人用户ID，可为空 */
    initiatorId!: string | undefined;
    /** 流程定义ID */
    processDefinitionId!: string | undefined;
    /** 流程定义Key */
    processDefinitionKey!: string | undefined;
    /** 流程实例ID */
    processInstanceId!: string | undefined;
    /** 所属租户 */
    tenantId!: string | undefined;
    /** 表单数据 */
    values!: any | undefined;

    constructor(data?: IProcessInstanceRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.businessKey = data["businessKey"];
            if (data["ccToVos"] && data["ccToVos"].constructor === Array) {
                this.ccToVos = [] as any;
                for (let item of data["ccToVos"])
                    this.ccToVos!.push(CcToVo.fromJS(item));
            }
            this.initiatorId = data["initiatorId"];
            this.processDefinitionId = data["processDefinitionId"];
            this.processDefinitionKey = data["processDefinitionKey"];
            this.processInstanceId = data["processInstanceId"];
            this.tenantId = data["tenantId"];
            this.values = data["values"];
        }
    }

    static fromJS(data: any): ProcessInstanceRequest {
        data = typeof data === 'object' ? data : {};
        let result = new ProcessInstanceRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["businessKey"] = this.businessKey;
        if (this.ccToVos && this.ccToVos.constructor === Array) {
            data["ccToVos"] = [];
            for (let item of this.ccToVos)
                data["ccToVos"].push(item.toJSON());
        }
        data["initiatorId"] = this.initiatorId;
        data["processDefinitionId"] = this.processDefinitionId;
        data["processDefinitionKey"] = this.processDefinitionKey;
        data["processInstanceId"] = this.processInstanceId;
        data["tenantId"] = this.tenantId;
        data["values"] = this.values;
        return data; 
    }
}

export interface IProcessInstanceRequest {
    /** 业务Key */
    businessKey: string | undefined;
    /** 抄送人 */
    ccToVos: CcToVo[] | undefined;
    /** 发起人用户ID，可为空 */
    initiatorId: string | undefined;
    /** 流程定义ID */
    processDefinitionId: string | undefined;
    /** 流程定义Key */
    processDefinitionKey: string | undefined;
    /** 流程实例ID */
    processInstanceId: string | undefined;
    /** 所属租户 */
    tenantId: string | undefined;
    /** 表单数据 */
    values: any | undefined;
}

export class TaskRequest implements ITaskRequest {
    /** 节点ID */
    activityId!: string | undefined;
    /** 节点名称 */
    activityName!: string | undefined;
    /** 抄送人 */
    ccToVos!: CcToVo[] | undefined;
    /** 消息 */
    message!: string | undefined;
    /** 任务ID */
    taskId!: string | undefined;
    /** 任务ID集合 */
    taskIds!: string[] | undefined;
    /** 用户ID */
    userId!: string | undefined;
    /** 表单数据 */
    values!: any | undefined;

    constructor(data?: ITaskRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.activityId = data["activityId"];
            this.activityName = data["activityName"];
            if (data["ccToVos"] && data["ccToVos"].constructor === Array) {
                this.ccToVos = [] as any;
                for (let item of data["ccToVos"])
                    this.ccToVos!.push(CcToVo.fromJS(item));
            }
            this.message = data["message"];
            this.taskId = data["taskId"];
            if (data["taskIds"] && data["taskIds"].constructor === Array) {
                this.taskIds = [] as any;
                for (let item of data["taskIds"])
                    this.taskIds!.push(item);
            }
            this.userId = data["userId"];
            this.values = data["values"];
        }
    }

    static fromJS(data: any): TaskRequest {
        data = typeof data === 'object' ? data : {};
        let result = new TaskRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["activityId"] = this.activityId;
        data["activityName"] = this.activityName;
        if (this.ccToVos && this.ccToVos.constructor === Array) {
            data["ccToVos"] = [];
            for (let item of this.ccToVos)
                data["ccToVos"].push(item.toJSON());
        }
        data["message"] = this.message;
        data["taskId"] = this.taskId;
        if (this.taskIds && this.taskIds.constructor === Array) {
            data["taskIds"] = [];
            for (let item of this.taskIds)
                data["taskIds"].push(item);
        }
        data["userId"] = this.userId;
        data["values"] = this.values;
        return data; 
    }
}

export interface ITaskRequest {
    /** 节点ID */
    activityId: string | undefined;
    /** 节点名称 */
    activityName: string | undefined;
    /** 抄送人 */
    ccToVos: CcToVo[] | undefined;
    /** 消息 */
    message: string | undefined;
    /** 任务ID */
    taskId: string | undefined;
    /** 任务ID集合 */
    taskIds: string[] | undefined;
    /** 用户ID */
    userId: string | undefined;
    /** 表单数据 */
    values: any | undefined;
}

export class TaskResponse implements ITaskResponse {
    assignee!: string | undefined;
    assigneeName!: string | undefined;
    category!: string | undefined;
    claimTime!: Date | undefined;
    createTime!: Date | undefined;
    delegationState!: string | undefined;
    description!: string | undefined;
    dueDate!: Date | undefined;
    durationInMillis!: string | undefined;
    endTime!: Date | undefined;
    formKey!: string | undefined;
    id!: string | undefined;
    initiatorCanCompleteTask!: string | undefined;
    involvedPeople!: string[] | undefined;
    memberOfCandidateGroup!: string | undefined;
    memberOfCandidateUsers!: string | undefined;
    name!: string | undefined;
    owner!: string | undefined;
    ownerName!: string | undefined;
    parentTaskId!: string | undefined;
    parentTaskName!: string | undefined;
    priority!: number | undefined;
    processDefinitionCategory!: string | undefined;
    processDefinitionDeploymentId!: string | undefined;
    processDefinitionDescription!: string | undefined;
    processDefinitionId!: string | undefined;
    processDefinitionKey!: string | undefined;
    processDefinitionName!: string | undefined;
    processDefinitionVersion!: number | undefined;
    processInstanceId!: string | undefined;
    processInstanceName!: string | undefined;
    processInstanceStartUserId!: string | undefined;
    renderedTaskForm!: any | undefined;
    suspended!: boolean | undefined;
    taskDefinitionKey!: string | undefined;
    tenantId!: string | undefined;
    workTimeInMillis!: string | undefined;

    constructor(data?: ITaskResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.assignee = data["assignee"];
            this.assigneeName = data["assigneeName"];
            this.category = data["category"];
            this.claimTime = data["claimTime"] ? new Date(data["claimTime"].toString()) : <any>undefined;
            this.createTime = data["createTime"] ? new Date(data["createTime"].toString()) : <any>undefined;
            this.delegationState = data["delegationState"];
            this.description = data["description"];
            this.dueDate = data["dueDate"] ? new Date(data["dueDate"].toString()) : <any>undefined;
            this.durationInMillis = data["durationInMillis"];
            this.endTime = data["endTime"] ? new Date(data["endTime"].toString()) : <any>undefined;
            this.formKey = data["formKey"];
            this.id = data["id"];
            this.initiatorCanCompleteTask = data["initiatorCanCompleteTask"];
            if (data["involvedPeople"] && data["involvedPeople"].constructor === Array) {
                this.involvedPeople = [] as any;
                for (let item of data["involvedPeople"])
                    this.involvedPeople!.push(item);
            }
            this.memberOfCandidateGroup = data["memberOfCandidateGroup"];
            this.memberOfCandidateUsers = data["memberOfCandidateUsers"];
            this.name = data["name"];
            this.owner = data["owner"];
            this.ownerName = data["ownerName"];
            this.parentTaskId = data["parentTaskId"];
            this.parentTaskName = data["parentTaskName"];
            this.priority = data["priority"];
            this.processDefinitionCategory = data["processDefinitionCategory"];
            this.processDefinitionDeploymentId = data["processDefinitionDeploymentId"];
            this.processDefinitionDescription = data["processDefinitionDescription"];
            this.processDefinitionId = data["processDefinitionId"];
            this.processDefinitionKey = data["processDefinitionKey"];
            this.processDefinitionName = data["processDefinitionName"];
            this.processDefinitionVersion = data["processDefinitionVersion"];
            this.processInstanceId = data["processInstanceId"];
            this.processInstanceName = data["processInstanceName"];
            this.processInstanceStartUserId = data["processInstanceStartUserId"];
            this.renderedTaskForm = data["renderedTaskForm"];
            this.suspended = data["suspended"];
            this.taskDefinitionKey = data["taskDefinitionKey"];
            this.tenantId = data["tenantId"];
            this.workTimeInMillis = data["workTimeInMillis"];
        }
    }

    static fromJS(data: any): TaskResponse {
        data = typeof data === 'object' ? data : {};
        let result = new TaskResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["assignee"] = this.assignee;
        data["assigneeName"] = this.assigneeName;
        data["category"] = this.category;
        data["claimTime"] = this.claimTime ? this.claimTime.toISOString() : <any>undefined;
        data["createTime"] = this.createTime ? this.createTime.toISOString() : <any>undefined;
        data["delegationState"] = this.delegationState;
        data["description"] = this.description;
        data["dueDate"] = this.dueDate ? this.dueDate.toISOString() : <any>undefined;
        data["durationInMillis"] = this.durationInMillis;
        data["endTime"] = this.endTime ? this.endTime.toISOString() : <any>undefined;
        data["formKey"] = this.formKey;
        data["id"] = this.id;
        data["initiatorCanCompleteTask"] = this.initiatorCanCompleteTask;
        if (this.involvedPeople && this.involvedPeople.constructor === Array) {
            data["involvedPeople"] = [];
            for (let item of this.involvedPeople)
                data["involvedPeople"].push(item);
        }
        data["memberOfCandidateGroup"] = this.memberOfCandidateGroup;
        data["memberOfCandidateUsers"] = this.memberOfCandidateUsers;
        data["name"] = this.name;
        data["owner"] = this.owner;
        data["ownerName"] = this.ownerName;
        data["parentTaskId"] = this.parentTaskId;
        data["parentTaskName"] = this.parentTaskName;
        data["priority"] = this.priority;
        data["processDefinitionCategory"] = this.processDefinitionCategory;
        data["processDefinitionDeploymentId"] = this.processDefinitionDeploymentId;
        data["processDefinitionDescription"] = this.processDefinitionDescription;
        data["processDefinitionId"] = this.processDefinitionId;
        data["processDefinitionKey"] = this.processDefinitionKey;
        data["processDefinitionName"] = this.processDefinitionName;
        data["processDefinitionVersion"] = this.processDefinitionVersion;
        data["processInstanceId"] = this.processInstanceId;
        data["processInstanceName"] = this.processInstanceName;
        data["processInstanceStartUserId"] = this.processInstanceStartUserId;
        data["renderedTaskForm"] = this.renderedTaskForm;
        data["suspended"] = this.suspended;
        data["taskDefinitionKey"] = this.taskDefinitionKey;
        data["tenantId"] = this.tenantId;
        data["workTimeInMillis"] = this.workTimeInMillis;
        return data; 
    }
}

export interface ITaskResponse {
    assignee: string | undefined;
    assigneeName: string | undefined;
    category: string | undefined;
    claimTime: Date | undefined;
    createTime: Date | undefined;
    delegationState: string | undefined;
    description: string | undefined;
    dueDate: Date | undefined;
    durationInMillis: string | undefined;
    endTime: Date | undefined;
    formKey: string | undefined;
    id: string | undefined;
    initiatorCanCompleteTask: string | undefined;
    involvedPeople: string[] | undefined;
    memberOfCandidateGroup: string | undefined;
    memberOfCandidateUsers: string | undefined;
    name: string | undefined;
    owner: string | undefined;
    ownerName: string | undefined;
    parentTaskId: string | undefined;
    parentTaskName: string | undefined;
    priority: number | undefined;
    processDefinitionCategory: string | undefined;
    processDefinitionDeploymentId: string | undefined;
    processDefinitionDescription: string | undefined;
    processDefinitionId: string | undefined;
    processDefinitionKey: string | undefined;
    processDefinitionName: string | undefined;
    processDefinitionVersion: number | undefined;
    processInstanceId: string | undefined;
    processInstanceName: string | undefined;
    processInstanceStartUserId: string | undefined;
    renderedTaskForm: any | undefined;
    suspended: boolean | undefined;
    taskDefinitionKey: string | undefined;
    tenantId: string | undefined;
    workTimeInMillis: string | undefined;
}

export class TaskUpdateRequest implements ITaskUpdateRequest {
    /** 任务执行人 */
    assignee!: string | undefined;
    /** 分类 */
    category!: string | undefined;
    /** 描述 */
    description!: string | undefined;
    /** 到期日 */
    dueDate!: Date | undefined;
    /** 任务ID */
    id!: string | undefined;
    /** 任务名称 */
    name!: string | undefined;
    /** 任务所有人 */
    owner!: string | undefined;
    /** 任务优先级 */
    priority!: number | undefined;

    constructor(data?: ITaskUpdateRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.assignee = data["assignee"];
            this.category = data["category"];
            this.description = data["description"];
            this.dueDate = data["dueDate"] ? new Date(data["dueDate"].toString()) : <any>undefined;
            this.id = data["id"];
            this.name = data["name"];
            this.owner = data["owner"];
            this.priority = data["priority"];
        }
    }

    static fromJS(data: any): TaskUpdateRequest {
        data = typeof data === 'object' ? data : {};
        let result = new TaskUpdateRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["assignee"] = this.assignee;
        data["category"] = this.category;
        data["description"] = this.description;
        data["dueDate"] = this.dueDate ? this.dueDate.toISOString() : <any>undefined;
        data["id"] = this.id;
        data["name"] = this.name;
        data["owner"] = this.owner;
        data["priority"] = this.priority;
        return data; 
    }
}

export interface ITaskUpdateRequest {
    /** 任务执行人 */
    assignee: string | undefined;
    /** 分类 */
    category: string | undefined;
    /** 描述 */
    description: string | undefined;
    /** 到期日 */
    dueDate: Date | undefined;
    /** 任务ID */
    id: string | undefined;
    /** 任务名称 */
    name: string | undefined;
    /** 任务所有人 */
    owner: string | undefined;
    /** 任务优先级 */
    priority: number | undefined;
}

export enum OrderDirection {
    ASC = "ASC", 
    DESC = "DESC", 
}